// source: wisetime/user/timeline/v4/timeline.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_api_annotations_pb = require('../../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js');
goog.object.extend(proto, google_protobuf_duration_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_field_mask_pb = require('google-protobuf/google/protobuf/field_mask_pb.js');
goog.object.extend(proto, google_protobuf_field_mask_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var wisetime_type_site_ref_pb = require('../../../../wisetime/type/site_ref_pb.js');
goog.object.extend(proto, wisetime_type_site_ref_pb);
var wisetime_user_type_selected_timesheet_field_option_pb = require('../../../../wisetime/user/type/selected_timesheet_field_option_pb.js');
goog.object.extend(proto, wisetime_user_type_selected_timesheet_field_option_pb);
var wisetime_user_type_tag_ref_pb = require('../../../../wisetime/user/type/tag_ref_pb.js');
goog.object.extend(proto, wisetime_user_type_tag_ref_pb);
var wisetime_user_type_tag_category_ref_pb = require('../../../../wisetime/user/type/tag_category_ref_pb.js');
goog.object.extend(proto, wisetime_user_type_tag_category_ref_pb);
var wisetime_user_type_timeline_status_pb = require('../../../../wisetime/user/type/timeline_status_pb.js');
goog.object.extend(proto, wisetime_user_type_timeline_status_pb);
goog.exportSymbol('proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.AddManualTimeRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.AddManualTimeResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.AddToTimeGroupRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.AffectedRowsResult', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.AttachTagRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.AttachTagResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.CancelPostTimeRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.CancelPostTimeResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.CreateTimeGroupRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.DaySummary', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.DetachTagCategoryRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.TargetCase', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.DetachTagCategoryResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.DetachTagRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.DetachTagRequest.TargetCase', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.DetachTagResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.EmptyTrashRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.EmptyTrashResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.GetTimelineStatusRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.IdList', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.ListDaySummariesRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.ListDaySummariesResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.ListTimelinesRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.ListTimelinesResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.ManualTimeRow', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.ManualTimeRow.ManualTimeCategory', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.NarrativeSource', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.PostStatus', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.PostTimeGroup', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.PostTimeRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.PostTimeResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.SetActivityTypeRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.SetActivityTypeResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.TagSuggestion', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.TimeGroup', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.TimeGroup.TimeGroupSource', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.TimeGroupUpdate', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.TimeRow', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.Timeline', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.TimelineMarker', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.TimelineUpdate', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.TrashStatus', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.TrashTimeRowsRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.TrashTimeRowsResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.TargetCase', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.ListTimelinesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.ListTimelinesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.ListTimelinesRequest.displayName = 'proto.wisetime.user.timeline.v4.ListTimelinesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.ListTimelinesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.ListTimelinesResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.ListTimelinesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.ListTimelinesResponse.displayName = 'proto.wisetime.user.timeline.v4.ListTimelinesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.Timeline = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.Timeline.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.Timeline, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.Timeline.displayName = 'proto.wisetime.user.timeline.v4.Timeline';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.GetTimelineStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.GetTimelineStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.GetTimelineStatusRequest.displayName = 'proto.wisetime.user.timeline.v4.GetTimelineStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.ListDaySummariesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.ListDaySummariesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.ListDaySummariesRequest.displayName = 'proto.wisetime.user.timeline.v4.ListDaySummariesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.ListDaySummariesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.ListDaySummariesResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.ListDaySummariesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.ListDaySummariesResponse.displayName = 'proto.wisetime.user.timeline.v4.ListDaySummariesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.DaySummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.DaySummary.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.DaySummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.DaySummary.displayName = 'proto.wisetime.user.timeline.v4.DaySummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.displayName = 'proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.displayName = 'proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.displayName = 'proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest.displayName = 'proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.TimelineUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.TimelineUpdate.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.TimelineUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.TimelineUpdate.displayName = 'proto.wisetime.user.timeline.v4.TimelineUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.PostTimeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.PostTimeRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.PostTimeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.PostTimeRequest.displayName = 'proto.wisetime.user.timeline.v4.PostTimeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.CancelPostTimeRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.CancelPostTimeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.CancelPostTimeRequest.displayName = 'proto.wisetime.user.timeline.v4.CancelPostTimeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.CancelPostTimeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.CancelPostTimeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.CancelPostTimeResponse.displayName = 'proto.wisetime.user.timeline.v4.CancelPostTimeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.PostTimeGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.PostTimeGroup.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.PostTimeGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.PostTimeGroup.displayName = 'proto.wisetime.user.timeline.v4.PostTimeGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.PostTimeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.PostTimeResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.PostTimeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.PostTimeResponse.displayName = 'proto.wisetime.user.timeline.v4.PostTimeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.displayName = 'proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.displayName = 'proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.IdList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.IdList.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.IdList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.IdList.displayName = 'proto.wisetime.user.timeline.v4.IdList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.AttachTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.AttachTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.AttachTagRequest.displayName = 'proto.wisetime.user.timeline.v4.AttachTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.AttachTagResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.AttachTagResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.AttachTagResponse.displayName = 'proto.wisetime.user.timeline.v4.AttachTagResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.DetachTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.wisetime.user.timeline.v4.DetachTagRequest.oneofGroups_);
};
goog.inherits(proto.wisetime.user.timeline.v4.DetachTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.DetachTagRequest.displayName = 'proto.wisetime.user.timeline.v4.DetachTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.DetachTagResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.DetachTagResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.DetachTagResponse.displayName = 'proto.wisetime.user.timeline.v4.DetachTagResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.oneofGroups_);
};
goog.inherits(proto.wisetime.user.timeline.v4.DetachTagCategoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.displayName = 'proto.wisetime.user.timeline.v4.DetachTagCategoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.DetachTagCategoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.DetachTagCategoryResponse.displayName = 'proto.wisetime.user.timeline.v4.DetachTagCategoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest.displayName = 'proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.displayName = 'proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest.displayName = 'proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.displayName = 'proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.SetActivityTypeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.SetActivityTypeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.SetActivityTypeRequest.displayName = 'proto.wisetime.user.timeline.v4.SetActivityTypeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.SetActivityTypeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.SetActivityTypeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.SetActivityTypeResponse.displayName = 'proto.wisetime.user.timeline.v4.SetActivityTypeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.oneofGroups_);
};
goog.inherits(proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.displayName = 'proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse.displayName = 'proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.displayName = 'proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.displayName = 'proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.displayName = 'proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.displayName = 'proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.displayName = 'proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.displayName = 'proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.TrashTimeRowsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.displayName = 'proto.wisetime.user.timeline.v4.TrashTimeRowsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.TrashTimeRowsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.TrashTimeRowsResponse.displayName = 'proto.wisetime.user.timeline.v4.TrashTimeRowsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.displayName = 'proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse.displayName = 'proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.displayName = 'proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse.displayName = 'proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.EmptyTrashRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.EmptyTrashRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.EmptyTrashRequest.displayName = 'proto.wisetime.user.timeline.v4.EmptyTrashRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.EmptyTrashResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.EmptyTrashResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.EmptyTrashResponse.displayName = 'proto.wisetime.user.timeline.v4.EmptyTrashResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.CreateTimeGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.displayName = 'proto.wisetime.user.timeline.v4.CreateTimeGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.displayName = 'proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.TimeGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.TimeGroup.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.TimeGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.TimeGroup.displayName = 'proto.wisetime.user.timeline.v4.TimeGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.AddToTimeGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.AddToTimeGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.displayName = 'proto.wisetime.user.timeline.v4.AddToTimeGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.displayName = 'proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.displayName = 'proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.displayName = 'proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.TimeGroupUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.TimeGroupUpdate.displayName = 'proto.wisetime.user.timeline.v4.TimeGroupUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest.displayName = 'proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.AffectedRowsResult.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.AffectedRowsResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.AffectedRowsResult.displayName = 'proto.wisetime.user.timeline.v4.AffectedRowsResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.displayName = 'proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest.displayName = 'proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.AddManualTimeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.AddManualTimeRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.AddManualTimeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.AddManualTimeRequest.displayName = 'proto.wisetime.user.timeline.v4.AddManualTimeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.ManualTimeRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.ManualTimeRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.ManualTimeRow.displayName = 'proto.wisetime.user.timeline.v4.ManualTimeRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.AddManualTimeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.AddManualTimeResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.AddManualTimeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.AddManualTimeResponse.displayName = 'proto.wisetime.user.timeline.v4.AddManualTimeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.displayName = 'proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.displayName = 'proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.TimeRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.TimeRow.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.TimeRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.TimeRow.displayName = 'proto.wisetime.user.timeline.v4.TimeRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.TagSuggestion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.TagSuggestion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.TagSuggestion.displayName = 'proto.wisetime.user.timeline.v4.TagSuggestion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.TimelineMarker = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.TimelineMarker.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.TimelineMarker, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.TimelineMarker.displayName = 'proto.wisetime.user.timeline.v4.TimelineMarker';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.displayName = 'proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.displayName = 'proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse.displayName = 'proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.displayName = 'proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.ListTimelinesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.ListTimelinesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.ListTimelinesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ListTimelinesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: jspb.Message.getFieldWithDefault(msg, 1, ""),
    endDate: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.ListTimelinesRequest}
 */
proto.wisetime.user.timeline.v4.ListTimelinesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.ListTimelinesRequest;
  return proto.wisetime.user.timeline.v4.ListTimelinesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.ListTimelinesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.ListTimelinesRequest}
 */
proto.wisetime.user.timeline.v4.ListTimelinesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.ListTimelinesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.ListTimelinesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.ListTimelinesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ListTimelinesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEndDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string start_date = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.ListTimelinesRequest.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.ListTimelinesRequest} returns this
 */
proto.wisetime.user.timeline.v4.ListTimelinesRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string end_date = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.ListTimelinesRequest.prototype.getEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.ListTimelinesRequest} returns this
 */
proto.wisetime.user.timeline.v4.ListTimelinesRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.ListTimelinesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.ListTimelinesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.ListTimelinesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.ListTimelinesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ListTimelinesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    timelinesList: jspb.Message.toObjectList(msg.getTimelinesList(),
    proto.wisetime.user.timeline.v4.Timeline.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.ListTimelinesResponse}
 */
proto.wisetime.user.timeline.v4.ListTimelinesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.ListTimelinesResponse;
  return proto.wisetime.user.timeline.v4.ListTimelinesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.ListTimelinesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.ListTimelinesResponse}
 */
proto.wisetime.user.timeline.v4.ListTimelinesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.timeline.v4.Timeline;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.Timeline.deserializeBinaryFromReader);
      msg.addTimelines(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.ListTimelinesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.ListTimelinesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.ListTimelinesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ListTimelinesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimelinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.user.timeline.v4.Timeline.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Timeline timelines = 1;
 * @return {!Array<!proto.wisetime.user.timeline.v4.Timeline>}
 */
proto.wisetime.user.timeline.v4.ListTimelinesResponse.prototype.getTimelinesList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.Timeline>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.Timeline, 1));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.Timeline>} value
 * @return {!proto.wisetime.user.timeline.v4.ListTimelinesResponse} returns this
*/
proto.wisetime.user.timeline.v4.ListTimelinesResponse.prototype.setTimelinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.Timeline=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.Timeline}
 */
proto.wisetime.user.timeline.v4.ListTimelinesResponse.prototype.addTimelines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.user.timeline.v4.Timeline, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.ListTimelinesResponse} returns this
 */
proto.wisetime.user.timeline.v4.ListTimelinesResponse.prototype.clearTimelinesList = function() {
  return this.setTimelinesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.Timeline.repeatedFields_ = [2,1,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.Timeline.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.Timeline.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.Timeline} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.Timeline.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 5, ""),
    timeRowsInRangeList: jspb.Message.toObjectList(msg.getTimeRowsInRangeList(),
    proto.wisetime.user.timeline.v4.TimeRow.toObject, includeInstance),
    timeGroupsInRangeList: jspb.Message.toObjectList(msg.getTimeGroupsInRangeList(),
    proto.wisetime.user.timeline.v4.TimeGroup.toObject, includeInstance),
    markersList: jspb.Message.toObjectList(msg.getMarkersList(),
    proto.wisetime.user.timeline.v4.TimelineMarker.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.Timeline}
 */
proto.wisetime.user.timeline.v4.Timeline.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.Timeline;
  return proto.wisetime.user.timeline.v4.Timeline.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.Timeline} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.Timeline}
 */
proto.wisetime.user.timeline.v4.Timeline.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = new proto.wisetime.user.timeline.v4.TimeRow;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.TimeRow.deserializeBinaryFromReader);
      msg.addTimeRowsInRange(value);
      break;
    case 1:
      var value = new proto.wisetime.user.timeline.v4.TimeGroup;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.TimeGroup.deserializeBinaryFromReader);
      msg.addTimeGroupsInRange(value);
      break;
    case 6:
      var value = new proto.wisetime.user.timeline.v4.TimelineMarker;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.TimelineMarker.deserializeBinaryFromReader);
      msg.addMarkers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.Timeline.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.Timeline.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.Timeline} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.Timeline.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTimeRowsInRangeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.wisetime.user.timeline.v4.TimeRow.serializeBinaryToWriter
    );
  }
  f = message.getTimeGroupsInRangeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.user.timeline.v4.TimeGroup.serializeBinaryToWriter
    );
  }
  f = message.getMarkersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.wisetime.user.timeline.v4.TimelineMarker.serializeBinaryToWriter
    );
  }
};


/**
 * optional string date = 5;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.Timeline.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.Timeline} returns this
 */
proto.wisetime.user.timeline.v4.Timeline.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated TimeRow time_rows_in_range = 2;
 * @return {!Array<!proto.wisetime.user.timeline.v4.TimeRow>}
 */
proto.wisetime.user.timeline.v4.Timeline.prototype.getTimeRowsInRangeList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.TimeRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.TimeRow, 2));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.TimeRow>} value
 * @return {!proto.wisetime.user.timeline.v4.Timeline} returns this
*/
proto.wisetime.user.timeline.v4.Timeline.prototype.setTimeRowsInRangeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TimeRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.TimeRow}
 */
proto.wisetime.user.timeline.v4.Timeline.prototype.addTimeRowsInRange = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.wisetime.user.timeline.v4.TimeRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.Timeline} returns this
 */
proto.wisetime.user.timeline.v4.Timeline.prototype.clearTimeRowsInRangeList = function() {
  return this.setTimeRowsInRangeList([]);
};


/**
 * repeated TimeGroup time_groups_in_range = 1;
 * @return {!Array<!proto.wisetime.user.timeline.v4.TimeGroup>}
 */
proto.wisetime.user.timeline.v4.Timeline.prototype.getTimeGroupsInRangeList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.TimeGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.TimeGroup, 1));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.TimeGroup>} value
 * @return {!proto.wisetime.user.timeline.v4.Timeline} returns this
*/
proto.wisetime.user.timeline.v4.Timeline.prototype.setTimeGroupsInRangeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TimeGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup}
 */
proto.wisetime.user.timeline.v4.Timeline.prototype.addTimeGroupsInRange = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.user.timeline.v4.TimeGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.Timeline} returns this
 */
proto.wisetime.user.timeline.v4.Timeline.prototype.clearTimeGroupsInRangeList = function() {
  return this.setTimeGroupsInRangeList([]);
};


/**
 * repeated TimelineMarker markers = 6;
 * @return {!Array<!proto.wisetime.user.timeline.v4.TimelineMarker>}
 */
proto.wisetime.user.timeline.v4.Timeline.prototype.getMarkersList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.TimelineMarker>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.TimelineMarker, 6));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.TimelineMarker>} value
 * @return {!proto.wisetime.user.timeline.v4.Timeline} returns this
*/
proto.wisetime.user.timeline.v4.Timeline.prototype.setMarkersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TimelineMarker=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.TimelineMarker}
 */
proto.wisetime.user.timeline.v4.Timeline.prototype.addMarkers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.wisetime.user.timeline.v4.TimelineMarker, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.Timeline} returns this
 */
proto.wisetime.user.timeline.v4.Timeline.prototype.clearMarkersList = function() {
  return this.setMarkersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.GetTimelineStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.GetTimelineStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.GetTimelineStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.GetTimelineStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.GetTimelineStatusRequest}
 */
proto.wisetime.user.timeline.v4.GetTimelineStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.GetTimelineStatusRequest;
  return proto.wisetime.user.timeline.v4.GetTimelineStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.GetTimelineStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.GetTimelineStatusRequest}
 */
proto.wisetime.user.timeline.v4.GetTimelineStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.GetTimelineStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.GetTimelineStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.GetTimelineStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.GetTimelineStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.ListDaySummariesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.ListDaySummariesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.ListDaySummariesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ListDaySummariesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: jspb.Message.getFieldWithDefault(msg, 1, ""),
    endDate: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.ListDaySummariesRequest}
 */
proto.wisetime.user.timeline.v4.ListDaySummariesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.ListDaySummariesRequest;
  return proto.wisetime.user.timeline.v4.ListDaySummariesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.ListDaySummariesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.ListDaySummariesRequest}
 */
proto.wisetime.user.timeline.v4.ListDaySummariesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.ListDaySummariesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.ListDaySummariesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.ListDaySummariesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ListDaySummariesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEndDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string start_date = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.ListDaySummariesRequest.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.ListDaySummariesRequest} returns this
 */
proto.wisetime.user.timeline.v4.ListDaySummariesRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string end_date = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.ListDaySummariesRequest.prototype.getEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.ListDaySummariesRequest} returns this
 */
proto.wisetime.user.timeline.v4.ListDaySummariesRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.ListDaySummariesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.ListDaySummariesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.ListDaySummariesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.ListDaySummariesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ListDaySummariesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    daySummariesList: jspb.Message.toObjectList(msg.getDaySummariesList(),
    proto.wisetime.user.timeline.v4.DaySummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.ListDaySummariesResponse}
 */
proto.wisetime.user.timeline.v4.ListDaySummariesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.ListDaySummariesResponse;
  return proto.wisetime.user.timeline.v4.ListDaySummariesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.ListDaySummariesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.ListDaySummariesResponse}
 */
proto.wisetime.user.timeline.v4.ListDaySummariesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.timeline.v4.DaySummary;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.DaySummary.deserializeBinaryFromReader);
      msg.addDaySummaries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.ListDaySummariesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.ListDaySummariesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.ListDaySummariesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ListDaySummariesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDaySummariesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.user.timeline.v4.DaySummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DaySummary day_summaries = 1;
 * @return {!Array<!proto.wisetime.user.timeline.v4.DaySummary>}
 */
proto.wisetime.user.timeline.v4.ListDaySummariesResponse.prototype.getDaySummariesList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.DaySummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.DaySummary, 1));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.DaySummary>} value
 * @return {!proto.wisetime.user.timeline.v4.ListDaySummariesResponse} returns this
*/
proto.wisetime.user.timeline.v4.ListDaySummariesResponse.prototype.setDaySummariesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.DaySummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.DaySummary}
 */
proto.wisetime.user.timeline.v4.ListDaySummariesResponse.prototype.addDaySummaries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.user.timeline.v4.DaySummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.ListDaySummariesResponse} returns this
 */
proto.wisetime.user.timeline.v4.ListDaySummariesResponse.prototype.clearDaySummariesList = function() {
  return this.setDaySummariesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.DaySummary.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.DaySummary.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.DaySummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.DaySummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DaySummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 1, ""),
    totalUnposted: (f = msg.getTotalUnposted()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    hasError: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    timePostedToSiteList: jspb.Message.toObjectList(msg.getTimePostedToSiteList(),
    proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.DaySummary}
 */
proto.wisetime.user.timeline.v4.DaySummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.DaySummary;
  return proto.wisetime.user.timeline.v4.DaySummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.DaySummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.DaySummary}
 */
proto.wisetime.user.timeline.v4.DaySummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 3:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTotalUnposted(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasError(value);
      break;
    case 6:
      var value = new proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.deserializeBinaryFromReader);
      msg.addTimePostedToSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.DaySummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.DaySummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.DaySummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DaySummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalUnposted();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getHasError();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getTimePostedToSiteList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    totalPosted: (f = msg.getTotalPosted()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite}
 */
proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite;
  return proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite}
 */
proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTotalPosted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalPosted();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite} returns this
 */
proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Duration total_posted = 2;
 * @return {?proto.google.protobuf.Duration}
 */
proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.prototype.getTotalPosted = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 2));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite} returns this
*/
proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.prototype.setTotalPosted = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite} returns this
 */
proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.prototype.clearTotalPosted = function() {
  return this.setTotalPosted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite.prototype.hasTotalPosted = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.DaySummary.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.DaySummary} returns this
 */
proto.wisetime.user.timeline.v4.DaySummary.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Duration total_unposted = 3;
 * @return {?proto.google.protobuf.Duration}
 */
proto.wisetime.user.timeline.v4.DaySummary.prototype.getTotalUnposted = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 3));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.DaySummary} returns this
*/
proto.wisetime.user.timeline.v4.DaySummary.prototype.setTotalUnposted = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.DaySummary} returns this
 */
proto.wisetime.user.timeline.v4.DaySummary.prototype.clearTotalUnposted = function() {
  return this.setTotalUnposted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.DaySummary.prototype.hasTotalUnposted = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool has_error = 5;
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.DaySummary.prototype.getHasError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.wisetime.user.timeline.v4.DaySummary} returns this
 */
proto.wisetime.user.timeline.v4.DaySummary.prototype.setHasError = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated TimePostedToSite time_posted_to_site = 6;
 * @return {!Array<!proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite>}
 */
proto.wisetime.user.timeline.v4.DaySummary.prototype.getTimePostedToSiteList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite, 6));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite>} value
 * @return {!proto.wisetime.user.timeline.v4.DaySummary} returns this
*/
proto.wisetime.user.timeline.v4.DaySummary.prototype.setTimePostedToSiteList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite}
 */
proto.wisetime.user.timeline.v4.DaySummary.prototype.addTimePostedToSite = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.wisetime.user.timeline.v4.DaySummary.TimePostedToSite, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.DaySummary} returns this
 */
proto.wisetime.user.timeline.v4.DaySummary.prototype.clearTimePostedToSiteList = function() {
  return this.setTimePostedToSiteList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    startActivityDate: jspb.Message.getFieldWithDefault(msg, 1, 0),
    endActivityDate: jspb.Message.getFieldWithDefault(msg, 2, 0),
    postStatus: jspb.Message.getFieldWithDefault(msg, 3, 0),
    trashStatus: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest;
  return proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStartActivityDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setEndActivityDate(value);
      break;
    case 3:
      var value = /** @type {!proto.wisetime.user.timeline.v4.PostStatus} */ (reader.readEnum());
      msg.setPostStatus(value);
      break;
    case 4:
      var value = /** @type {!proto.wisetime.user.timeline.v4.TrashStatus} */ (reader.readEnum());
      msg.setTrashStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartActivityDate();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getEndActivityDate();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = /** @type {!proto.wisetime.user.timeline.v4.PostStatus} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {!proto.wisetime.user.timeline.v4.TrashStatus} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional uint32 start_activity_date = 1;
 * @return {number}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.prototype.getStartActivityDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest} returns this
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.prototype.setStartActivityDate = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 end_activity_date = 2;
 * @return {number}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.prototype.getEndActivityDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest} returns this
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.prototype.setEndActivityDate = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional PostStatus post_status = 3;
 * @return {!proto.wisetime.user.timeline.v4.PostStatus}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.prototype.getPostStatus = function() {
  return /** @type {!proto.wisetime.user.timeline.v4.PostStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.wisetime.user.timeline.v4.PostStatus} value
 * @return {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest} returns this
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.prototype.setPostStatus = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest} returns this
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.prototype.clearPostStatus = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.prototype.hasPostStatus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TrashStatus trash_status = 4;
 * @return {!proto.wisetime.user.timeline.v4.TrashStatus}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.prototype.getTrashStatus = function() {
  return /** @type {!proto.wisetime.user.timeline.v4.TrashStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TrashStatus} value
 * @return {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest} returns this
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.prototype.setTrashStatus = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest} returns this
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.prototype.clearTrashStatus = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateRequest.prototype.hasTrashStatus = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowsList: jspb.Message.toObjectList(msg.getTimeRowsList(),
    proto.wisetime.user.timeline.v4.TimeRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse;
  return proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.timeline.v4.TimeRow;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.TimeRow.deserializeBinaryFromReader);
      msg.addTimeRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.user.timeline.v4.TimeRow.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TimeRow time_rows = 1;
 * @return {!Array<!proto.wisetime.user.timeline.v4.TimeRow>}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.prototype.getTimeRowsList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.TimeRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.TimeRow, 1));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.TimeRow>} value
 * @return {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse} returns this
*/
proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.prototype.setTimeRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TimeRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.TimeRow}
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.prototype.addTimeRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.user.timeline.v4.TimeRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse} returns this
 */
proto.wisetime.user.timeline.v4.ListTimeRowsByDateResponse.prototype.clearTimeRowsList = function() {
  return this.setTimeRowsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest}
 */
proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest;
  return proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest}
 */
proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.WatchTimelineUpdatesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.TimelineUpdate.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.TimelineUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.TimelineUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.TimelineUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TimelineUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    datesWithUpdatesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.TimelineUpdate}
 */
proto.wisetime.user.timeline.v4.TimelineUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.TimelineUpdate;
  return proto.wisetime.user.timeline.v4.TimelineUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.TimelineUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.TimelineUpdate}
 */
proto.wisetime.user.timeline.v4.TimelineUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addDatesWithUpdates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.TimelineUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.TimelineUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.TimelineUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TimelineUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDatesWithUpdatesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * repeated string dates_with_updates = 3;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.TimelineUpdate.prototype.getDatesWithUpdatesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.TimelineUpdate} returns this
 */
proto.wisetime.user.timeline.v4.TimelineUpdate.prototype.setDatesWithUpdatesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.TimelineUpdate} returns this
 */
proto.wisetime.user.timeline.v4.TimelineUpdate.prototype.addDatesWithUpdates = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.TimelineUpdate} returns this
 */
proto.wisetime.user.timeline.v4.TimelineUpdate.prototype.clearDatesWithUpdatesList = function() {
  return this.setDatesWithUpdatesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.PostTimeRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.PostTimeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.PostTimeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.PostTimeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.PostTimeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    site: (f = msg.getSite()) && wisetime_type_site_ref_pb.SiteRef.toObject(includeInstance, f),
    timeGroupsList: jspb.Message.toObjectList(msg.getTimeGroupsList(),
    proto.wisetime.user.timeline.v4.PostTimeGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeRequest}
 */
proto.wisetime.user.timeline.v4.PostTimeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.PostTimeRequest;
  return proto.wisetime.user.timeline.v4.PostTimeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.PostTimeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeRequest}
 */
proto.wisetime.user.timeline.v4.PostTimeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new wisetime_type_site_ref_pb.SiteRef;
      reader.readMessage(value,wisetime_type_site_ref_pb.SiteRef.deserializeBinaryFromReader);
      msg.setSite(value);
      break;
    case 3:
      var value = new proto.wisetime.user.timeline.v4.PostTimeGroup;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.PostTimeGroup.deserializeBinaryFromReader);
      msg.addTimeGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.PostTimeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.PostTimeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.PostTimeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.PostTimeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      wisetime_type_site_ref_pb.SiteRef.serializeBinaryToWriter
    );
  }
  f = message.getTimeGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.wisetime.user.timeline.v4.PostTimeGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional wisetime.type.SiteRef site = 1;
 * @return {?proto.wisetime.type.SiteRef}
 */
proto.wisetime.user.timeline.v4.PostTimeRequest.prototype.getSite = function() {
  return /** @type{?proto.wisetime.type.SiteRef} */ (
    jspb.Message.getWrapperField(this, wisetime_type_site_ref_pb.SiteRef, 1));
};


/**
 * @param {?proto.wisetime.type.SiteRef|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeRequest} returns this
*/
proto.wisetime.user.timeline.v4.PostTimeRequest.prototype.setSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeRequest} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeRequest.prototype.clearSite = function() {
  return this.setSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.PostTimeRequest.prototype.hasSite = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated PostTimeGroup time_groups = 3;
 * @return {!Array<!proto.wisetime.user.timeline.v4.PostTimeGroup>}
 */
proto.wisetime.user.timeline.v4.PostTimeRequest.prototype.getTimeGroupsList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.PostTimeGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.PostTimeGroup, 3));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.PostTimeGroup>} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeRequest} returns this
*/
proto.wisetime.user.timeline.v4.PostTimeRequest.prototype.setTimeGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.PostTimeGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.PostTimeGroup}
 */
proto.wisetime.user.timeline.v4.PostTimeRequest.prototype.addTimeGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.wisetime.user.timeline.v4.PostTimeGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeRequest} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeRequest.prototype.clearTimeGroupsList = function() {
  return this.setTimeGroupsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.CancelPostTimeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.CancelPostTimeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeGroupIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    timeRowIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.CancelPostTimeRequest}
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.CancelPostTimeRequest;
  return proto.wisetime.user.timeline.v4.CancelPostTimeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.CancelPostTimeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.CancelPostTimeRequest}
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimeGroupIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimeRowIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.CancelPostTimeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.CancelPostTimeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeGroupIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getTimeRowIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string time_group_ids = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest.prototype.getTimeGroupIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.CancelPostTimeRequest} returns this
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest.prototype.setTimeGroupIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.CancelPostTimeRequest} returns this
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest.prototype.addTimeGroupIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.CancelPostTimeRequest} returns this
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest.prototype.clearTimeGroupIdsList = function() {
  return this.setTimeGroupIdsList([]);
};


/**
 * repeated string time_row_ids = 2;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest.prototype.getTimeRowIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.CancelPostTimeRequest} returns this
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest.prototype.setTimeRowIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.CancelPostTimeRequest} returns this
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest.prototype.addTimeRowIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.CancelPostTimeRequest} returns this
 */
proto.wisetime.user.timeline.v4.CancelPostTimeRequest.prototype.clearTimeRowIdsList = function() {
  return this.setTimeRowIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.CancelPostTimeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.CancelPostTimeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.CancelPostTimeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CancelPostTimeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.CancelPostTimeResponse}
 */
proto.wisetime.user.timeline.v4.CancelPostTimeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.CancelPostTimeResponse;
  return proto.wisetime.user.timeline.v4.CancelPostTimeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.CancelPostTimeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.CancelPostTimeResponse}
 */
proto.wisetime.user.timeline.v4.CancelPostTimeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.CancelPostTimeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.CancelPostTimeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.CancelPostTimeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CancelPostTimeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.repeatedFields_ = [2,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.PostTimeGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.PostTimeGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeGroupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tagsList: jspb.Message.toObjectList(msg.getTagsList(),
    wisetime_user_type_tag_ref_pb.TagRef.toObject, includeInstance),
    selectedTimesheetFieldOptionsList: jspb.Message.toObjectList(msg.getSelectedTimesheetFieldOptionsList(),
    wisetime_user_type_selected_timesheet_field_option_pb.SelectedTimesheetFieldOption.toObject, includeInstance),
    totalDuration: (f = msg.getTotalDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    roundedTotalDuration: (f = msg.getRoundedTotalDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeGroup}
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.PostTimeGroup;
  return proto.wisetime.user.timeline.v4.PostTimeGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.PostTimeGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeGroup}
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeGroupId(value);
      break;
    case 2:
      var value = new wisetime_user_type_tag_ref_pb.TagRef;
      reader.readMessage(value,wisetime_user_type_tag_ref_pb.TagRef.deserializeBinaryFromReader);
      msg.addTags(value);
      break;
    case 6:
      var value = new wisetime_user_type_selected_timesheet_field_option_pb.SelectedTimesheetFieldOption;
      reader.readMessage(value,wisetime_user_type_selected_timesheet_field_option_pb.SelectedTimesheetFieldOption.deserializeBinaryFromReader);
      msg.addSelectedTimesheetFieldOptions(value);
      break;
    case 4:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTotalDuration(value);
      break;
    case 5:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setRoundedTotalDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.PostTimeGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.PostTimeGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      wisetime_user_type_tag_ref_pb.TagRef.serializeBinaryToWriter
    );
  }
  f = message.getSelectedTimesheetFieldOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      wisetime_user_type_selected_timesheet_field_option_pb.SelectedTimesheetFieldOption.serializeBinaryToWriter
    );
  }
  f = message.getTotalDuration();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getRoundedTotalDuration();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
};


/**
 * optional string time_group_id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.getTimeGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.setTimeGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated wisetime.user.type.TagRef tags = 2;
 * @return {!Array<!proto.wisetime.user.type.TagRef>}
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.getTagsList = function() {
  return /** @type{!Array<!proto.wisetime.user.type.TagRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, wisetime_user_type_tag_ref_pb.TagRef, 2));
};


/**
 * @param {!Array<!proto.wisetime.user.type.TagRef>} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeGroup} returns this
*/
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.setTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.wisetime.user.type.TagRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.type.TagRef}
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.addTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.wisetime.user.type.TagRef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * repeated wisetime.user.type.SelectedTimesheetFieldOption selected_timesheet_field_options = 6;
 * @return {!Array<!proto.wisetime.user.type.SelectedTimesheetFieldOption>}
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.getSelectedTimesheetFieldOptionsList = function() {
  return /** @type{!Array<!proto.wisetime.user.type.SelectedTimesheetFieldOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, wisetime_user_type_selected_timesheet_field_option_pb.SelectedTimesheetFieldOption, 6));
};


/**
 * @param {!Array<!proto.wisetime.user.type.SelectedTimesheetFieldOption>} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeGroup} returns this
*/
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.setSelectedTimesheetFieldOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.wisetime.user.type.SelectedTimesheetFieldOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.type.SelectedTimesheetFieldOption}
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.addSelectedTimesheetFieldOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.wisetime.user.type.SelectedTimesheetFieldOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.clearSelectedTimesheetFieldOptionsList = function() {
  return this.setSelectedTimesheetFieldOptionsList([]);
};


/**
 * optional google.protobuf.Duration total_duration = 4;
 * @return {?proto.google.protobuf.Duration}
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.getTotalDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 4));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeGroup} returns this
*/
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.setTotalDuration = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.clearTotalDuration = function() {
  return this.setTotalDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.hasTotalDuration = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Duration rounded_total_duration = 5;
 * @return {?proto.google.protobuf.Duration}
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.getRoundedTotalDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 5));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeGroup} returns this
*/
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.setRoundedTotalDuration = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.clearRoundedTotalDuration = function() {
  return this.setRoundedTotalDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.PostTimeGroup.prototype.hasRoundedTotalDuration = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.repeatedFields_ = [1,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.PostTimeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.PostTimeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    postedToSiteId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    timeRowResultsList: jspb.Message.toObjectList(msg.getTimeRowResultsList(),
    proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.toObject, includeInstance),
    timeGroupResultsList: jspb.Message.toObjectList(msg.getTimeGroupResultsList(),
    proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.toObject, includeInstance),
    remainingUserUnpostedTime: (f = msg.getRemainingUserUnpostedTime()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.PostTimeResponse;
  return proto.wisetime.user.timeline.v4.PostTimeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.PostTimeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostedToSiteId(value);
      break;
    case 1:
      var value = new proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.deserializeBinaryFromReader);
      msg.addTimeRowResults(value);
      break;
    case 3:
      var value = new proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.deserializeBinaryFromReader);
      msg.addTimeGroupResults(value);
      break;
    case 2:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setRemainingUserUnpostedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.PostTimeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.PostTimeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPostedToSiteId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimeRowResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.serializeBinaryToWriter
    );
  }
  f = message.getTimeGroupResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.serializeBinaryToWriter
    );
  }
  f = message.getRemainingUserUnpostedTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    errorMessage: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult;
  return proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeRowId(value);
      break;
    case 3:
      var value = /** @type {!proto.wisetime.user.timeline.v4.PostStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string time_row_id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.prototype.getTimeRowId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.prototype.setTimeRowId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PostStatus status = 3;
 * @return {!proto.wisetime.user.timeline.v4.PostStatus}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.prototype.getStatus = function() {
  return /** @type {!proto.wisetime.user.timeline.v4.PostStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.wisetime.user.timeline.v4.PostStatus} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string error_message = 4;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.prototype.setErrorMessage = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.prototype.clearErrorMessage = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult.prototype.hasErrorMessage = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeGroupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    errorMessage: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult;
  return proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeGroupId(value);
      break;
    case 2:
      var value = /** @type {!proto.wisetime.user.timeline.v4.PostStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string time_group_id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.prototype.getTimeGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.prototype.setTimeGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PostStatus status = 2;
 * @return {!proto.wisetime.user.timeline.v4.PostStatus}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.prototype.getStatus = function() {
  return /** @type {!proto.wisetime.user.timeline.v4.PostStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.wisetime.user.timeline.v4.PostStatus} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string error_message = 3;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.prototype.setErrorMessage = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.prototype.clearErrorMessage = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult.prototype.hasErrorMessage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string posted_to_site_id = 4;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.getPostedToSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.setPostedToSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated TimeRowResult time_row_results = 1;
 * @return {!Array<!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult>}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.getTimeRowResultsList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult, 1));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult>} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse} returns this
*/
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.setTimeRowResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.addTimeRowResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.user.timeline.v4.PostTimeResponse.TimeRowResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.clearTimeRowResultsList = function() {
  return this.setTimeRowResultsList([]);
};


/**
 * repeated TimeGroupResult time_group_results = 3;
 * @return {!Array<!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult>}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.getTimeGroupResultsList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult, 3));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult>} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse} returns this
*/
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.setTimeGroupResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.addTimeGroupResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.wisetime.user.timeline.v4.PostTimeResponse.TimeGroupResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.clearTimeGroupResultsList = function() {
  return this.setTimeGroupResultsList([]);
};


/**
 * optional google.protobuf.Duration remaining_user_unposted_time = 2;
 * @return {?proto.google.protobuf.Duration}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.getRemainingUserUnpostedTime = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 2));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse} returns this
*/
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.setRemainingUserUnpostedTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.PostTimeResponse} returns this
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.clearRemainingUserUnpostedTime = function() {
  return this.setRemainingUserUnpostedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.PostTimeResponse.prototype.hasRemainingUserUnpostedTime = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.IdList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.IdList.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.IdList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.IdList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.IdList.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.IdList}
 */
proto.wisetime.user.timeline.v4.IdList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.IdList;
  return proto.wisetime.user.timeline.v4.IdList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.IdList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.IdList}
 */
proto.wisetime.user.timeline.v4.IdList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.IdList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.IdList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.IdList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.IdList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.IdList.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.IdList} returns this
 */
proto.wisetime.user.timeline.v4.IdList.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.IdList} returns this
 */
proto.wisetime.user.timeline.v4.IdList.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.IdList} returns this
 */
proto.wisetime.user.timeline.v4.IdList.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.AttachTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.AttachTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.AttachTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AttachTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowIds: (f = msg.getTimeRowIds()) && proto.wisetime.user.timeline.v4.IdList.toObject(includeInstance, f),
    timeGroupIds: (f = msg.getTimeGroupIds()) && proto.wisetime.user.timeline.v4.IdList.toObject(includeInstance, f),
    tagId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.AttachTagRequest}
 */
proto.wisetime.user.timeline.v4.AttachTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.AttachTagRequest;
  return proto.wisetime.user.timeline.v4.AttachTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.AttachTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.AttachTagRequest}
 */
proto.wisetime.user.timeline.v4.AttachTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.timeline.v4.IdList;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.IdList.deserializeBinaryFromReader);
      msg.setTimeRowIds(value);
      break;
    case 5:
      var value = new proto.wisetime.user.timeline.v4.IdList;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.IdList.deserializeBinaryFromReader);
      msg.setTimeGroupIds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTagId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.AttachTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.AttachTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.AttachTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AttachTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowIds();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.wisetime.user.timeline.v4.IdList.serializeBinaryToWriter
    );
  }
  f = message.getTimeGroupIds();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.wisetime.user.timeline.v4.IdList.serializeBinaryToWriter
    );
  }
  f = message.getTagId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional IdList time_row_ids = 1;
 * @return {?proto.wisetime.user.timeline.v4.IdList}
 */
proto.wisetime.user.timeline.v4.AttachTagRequest.prototype.getTimeRowIds = function() {
  return /** @type{?proto.wisetime.user.timeline.v4.IdList} */ (
    jspb.Message.getWrapperField(this, proto.wisetime.user.timeline.v4.IdList, 1));
};


/**
 * @param {?proto.wisetime.user.timeline.v4.IdList|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.AttachTagRequest} returns this
*/
proto.wisetime.user.timeline.v4.AttachTagRequest.prototype.setTimeRowIds = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.AttachTagRequest} returns this
 */
proto.wisetime.user.timeline.v4.AttachTagRequest.prototype.clearTimeRowIds = function() {
  return this.setTimeRowIds(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.AttachTagRequest.prototype.hasTimeRowIds = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional IdList time_group_ids = 5;
 * @return {?proto.wisetime.user.timeline.v4.IdList}
 */
proto.wisetime.user.timeline.v4.AttachTagRequest.prototype.getTimeGroupIds = function() {
  return /** @type{?proto.wisetime.user.timeline.v4.IdList} */ (
    jspb.Message.getWrapperField(this, proto.wisetime.user.timeline.v4.IdList, 5));
};


/**
 * @param {?proto.wisetime.user.timeline.v4.IdList|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.AttachTagRequest} returns this
*/
proto.wisetime.user.timeline.v4.AttachTagRequest.prototype.setTimeGroupIds = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.AttachTagRequest} returns this
 */
proto.wisetime.user.timeline.v4.AttachTagRequest.prototype.clearTimeGroupIds = function() {
  return this.setTimeGroupIds(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.AttachTagRequest.prototype.hasTimeGroupIds = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string tag_id = 4;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.AttachTagRequest.prototype.getTagId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.AttachTagRequest} returns this
 */
proto.wisetime.user.timeline.v4.AttachTagRequest.prototype.setTagId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.AttachTagResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.AttachTagResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.AttachTagResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AttachTagResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.AttachTagResponse}
 */
proto.wisetime.user.timeline.v4.AttachTagResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.AttachTagResponse;
  return proto.wisetime.user.timeline.v4.AttachTagResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.AttachTagResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.AttachTagResponse}
 */
proto.wisetime.user.timeline.v4.AttachTagResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.AttachTagResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.AttachTagResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.AttachTagResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AttachTagResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.TargetCase = {
  TARGET_NOT_SET: 0,
  TIME_ROW_IDS: 1,
  TIME_GROUP_ID: 2
};

/**
 * @return {proto.wisetime.user.timeline.v4.DetachTagRequest.TargetCase}
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.prototype.getTargetCase = function() {
  return /** @type {proto.wisetime.user.timeline.v4.DetachTagRequest.TargetCase} */(jspb.Message.computeOneofCase(this, proto.wisetime.user.timeline.v4.DetachTagRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.DetachTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.DetachTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowIds: (f = msg.getTimeRowIds()) && proto.wisetime.user.timeline.v4.IdList.toObject(includeInstance, f),
    timeGroupId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tagId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.DetachTagRequest}
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.DetachTagRequest;
  return proto.wisetime.user.timeline.v4.DetachTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.DetachTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.DetachTagRequest}
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.timeline.v4.IdList;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.IdList.deserializeBinaryFromReader);
      msg.setTimeRowIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeGroupId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTagId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.DetachTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.DetachTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowIds();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.wisetime.user.timeline.v4.IdList.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTagId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional IdList time_row_ids = 1;
 * @return {?proto.wisetime.user.timeline.v4.IdList}
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.prototype.getTimeRowIds = function() {
  return /** @type{?proto.wisetime.user.timeline.v4.IdList} */ (
    jspb.Message.getWrapperField(this, proto.wisetime.user.timeline.v4.IdList, 1));
};


/**
 * @param {?proto.wisetime.user.timeline.v4.IdList|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.DetachTagRequest} returns this
*/
proto.wisetime.user.timeline.v4.DetachTagRequest.prototype.setTimeRowIds = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.wisetime.user.timeline.v4.DetachTagRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.DetachTagRequest} returns this
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.prototype.clearTimeRowIds = function() {
  return this.setTimeRowIds(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.prototype.hasTimeRowIds = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string time_group_id = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.prototype.getTimeGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.DetachTagRequest} returns this
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.prototype.setTimeGroupId = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.wisetime.user.timeline.v4.DetachTagRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.DetachTagRequest} returns this
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.prototype.clearTimeGroupId = function() {
  return jspb.Message.setOneofField(this, 2, proto.wisetime.user.timeline.v4.DetachTagRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.prototype.hasTimeGroupId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string tag_id = 4;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.prototype.getTagId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.DetachTagRequest} returns this
 */
proto.wisetime.user.timeline.v4.DetachTagRequest.prototype.setTagId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.DetachTagResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.DetachTagResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.DetachTagResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DetachTagResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.DetachTagResponse}
 */
proto.wisetime.user.timeline.v4.DetachTagResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.DetachTagResponse;
  return proto.wisetime.user.timeline.v4.DetachTagResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.DetachTagResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.DetachTagResponse}
 */
proto.wisetime.user.timeline.v4.DetachTagResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.DetachTagResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.DetachTagResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.DetachTagResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DetachTagResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.TargetCase = {
  TARGET_NOT_SET: 0,
  TIME_ROW_IDS: 1,
  TIME_GROUP_ID: 2
};

/**
 * @return {proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.TargetCase}
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.prototype.getTargetCase = function() {
  return /** @type {proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.TargetCase} */(jspb.Message.computeOneofCase(this, proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.DetachTagCategoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowIds: (f = msg.getTimeRowIds()) && proto.wisetime.user.timeline.v4.IdList.toObject(includeInstance, f),
    timeGroupId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tagCategoryId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.DetachTagCategoryRequest}
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.DetachTagCategoryRequest;
  return proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.DetachTagCategoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.DetachTagCategoryRequest}
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.timeline.v4.IdList;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.IdList.deserializeBinaryFromReader);
      msg.setTimeRowIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeGroupId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTagCategoryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.DetachTagCategoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowIds();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.wisetime.user.timeline.v4.IdList.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTagCategoryId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional IdList time_row_ids = 1;
 * @return {?proto.wisetime.user.timeline.v4.IdList}
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.prototype.getTimeRowIds = function() {
  return /** @type{?proto.wisetime.user.timeline.v4.IdList} */ (
    jspb.Message.getWrapperField(this, proto.wisetime.user.timeline.v4.IdList, 1));
};


/**
 * @param {?proto.wisetime.user.timeline.v4.IdList|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.DetachTagCategoryRequest} returns this
*/
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.prototype.setTimeRowIds = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.DetachTagCategoryRequest} returns this
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.prototype.clearTimeRowIds = function() {
  return this.setTimeRowIds(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.prototype.hasTimeRowIds = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string time_group_id = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.prototype.getTimeGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.DetachTagCategoryRequest} returns this
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.prototype.setTimeGroupId = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.DetachTagCategoryRequest} returns this
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.prototype.clearTimeGroupId = function() {
  return jspb.Message.setOneofField(this, 2, proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.prototype.hasTimeGroupId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string tag_category_id = 3;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.prototype.getTagCategoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.DetachTagCategoryRequest} returns this
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryRequest.prototype.setTagCategoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.DetachTagCategoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.DetachTagCategoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.DetachTagCategoryResponse}
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.DetachTagCategoryResponse;
  return proto.wisetime.user.timeline.v4.DetachTagCategoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.DetachTagCategoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.DetachTagCategoryResponse}
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.DetachTagCategoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.DetachTagCategoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DetachTagCategoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagSuggestionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest}
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest;
  return proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest}
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTagSuggestionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagSuggestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tag_suggestion_id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest.prototype.getTagSuggestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest} returns this
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionRequest.prototype.setTagSuggestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    updatedTimeRowsList: jspb.Message.toObjectList(msg.getUpdatedTimeRowsList(),
    proto.wisetime.user.timeline.v4.TimeRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse}
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse;
  return proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse}
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.timeline.v4.TimeRow;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.TimeRow.deserializeBinaryFromReader);
      msg.addUpdatedTimeRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdatedTimeRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.user.timeline.v4.TimeRow.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TimeRow updated_time_rows = 1;
 * @return {!Array<!proto.wisetime.user.timeline.v4.TimeRow>}
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.prototype.getUpdatedTimeRowsList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.TimeRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.TimeRow, 1));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.TimeRow>} value
 * @return {!proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse} returns this
*/
proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.prototype.setUpdatedTimeRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TimeRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.TimeRow}
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.prototype.addUpdatedTimeRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.user.timeline.v4.TimeRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse} returns this
 */
proto.wisetime.user.timeline.v4.AcceptTagSuggestionResponse.prototype.clearUpdatedTimeRowsList = function() {
  return this.setUpdatedTimeRowsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagSuggestionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest}
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest;
  return proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest}
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTagSuggestionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagSuggestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tag_suggestion_id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest.prototype.getTagSuggestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest} returns this
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionRequest.prototype.setTagSuggestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    updatedTimeRowsList: jspb.Message.toObjectList(msg.getUpdatedTimeRowsList(),
    proto.wisetime.user.timeline.v4.TimeRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse}
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse;
  return proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse}
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.timeline.v4.TimeRow;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.TimeRow.deserializeBinaryFromReader);
      msg.addUpdatedTimeRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdatedTimeRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.user.timeline.v4.TimeRow.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TimeRow updated_time_rows = 1;
 * @return {!Array<!proto.wisetime.user.timeline.v4.TimeRow>}
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.prototype.getUpdatedTimeRowsList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.TimeRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.TimeRow, 1));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.TimeRow>} value
 * @return {!proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse} returns this
*/
proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.prototype.setUpdatedTimeRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TimeRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.TimeRow}
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.prototype.addUpdatedTimeRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.user.timeline.v4.TimeRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse} returns this
 */
proto.wisetime.user.timeline.v4.DeclineTagSuggestionResponse.prototype.clearUpdatedTimeRowsList = function() {
  return this.setUpdatedTimeRowsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.SetActivityTypeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.SetActivityTypeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.SetActivityTypeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.SetActivityTypeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowIds: (f = msg.getTimeRowIds()) && proto.wisetime.user.timeline.v4.IdList.toObject(includeInstance, f),
    activityTypeId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.SetActivityTypeRequest}
 */
proto.wisetime.user.timeline.v4.SetActivityTypeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.SetActivityTypeRequest;
  return proto.wisetime.user.timeline.v4.SetActivityTypeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.SetActivityTypeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.SetActivityTypeRequest}
 */
proto.wisetime.user.timeline.v4.SetActivityTypeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.timeline.v4.IdList;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.IdList.deserializeBinaryFromReader);
      msg.setTimeRowIds(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityTypeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.SetActivityTypeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.SetActivityTypeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.SetActivityTypeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.SetActivityTypeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowIds();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.wisetime.user.timeline.v4.IdList.serializeBinaryToWriter
    );
  }
  f = message.getActivityTypeId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional IdList time_row_ids = 1;
 * @return {?proto.wisetime.user.timeline.v4.IdList}
 */
proto.wisetime.user.timeline.v4.SetActivityTypeRequest.prototype.getTimeRowIds = function() {
  return /** @type{?proto.wisetime.user.timeline.v4.IdList} */ (
    jspb.Message.getWrapperField(this, proto.wisetime.user.timeline.v4.IdList, 1));
};


/**
 * @param {?proto.wisetime.user.timeline.v4.IdList|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.SetActivityTypeRequest} returns this
*/
proto.wisetime.user.timeline.v4.SetActivityTypeRequest.prototype.setTimeRowIds = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.SetActivityTypeRequest} returns this
 */
proto.wisetime.user.timeline.v4.SetActivityTypeRequest.prototype.clearTimeRowIds = function() {
  return this.setTimeRowIds(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.SetActivityTypeRequest.prototype.hasTimeRowIds = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string activity_type_id = 3;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.SetActivityTypeRequest.prototype.getActivityTypeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.SetActivityTypeRequest} returns this
 */
proto.wisetime.user.timeline.v4.SetActivityTypeRequest.prototype.setActivityTypeId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.SetActivityTypeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.SetActivityTypeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.SetActivityTypeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.SetActivityTypeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.SetActivityTypeResponse}
 */
proto.wisetime.user.timeline.v4.SetActivityTypeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.SetActivityTypeResponse;
  return proto.wisetime.user.timeline.v4.SetActivityTypeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.SetActivityTypeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.SetActivityTypeResponse}
 */
proto.wisetime.user.timeline.v4.SetActivityTypeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.SetActivityTypeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.SetActivityTypeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.SetActivityTypeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.SetActivityTypeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.TargetCase = {
  TARGET_NOT_SET: 0,
  TIME_ROW_IDS: 1
};

/**
 * @return {proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.TargetCase}
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.prototype.getTargetCase = function() {
  return /** @type {proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.TargetCase} */(jspb.Message.computeOneofCase(this, proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowIds: (f = msg.getTimeRowIds()) && proto.wisetime.user.timeline.v4.IdList.toObject(includeInstance, f),
    activityTypeId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest}
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest;
  return proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest}
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.timeline.v4.IdList;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.IdList.deserializeBinaryFromReader);
      msg.setTimeRowIds(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityTypeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowIds();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.wisetime.user.timeline.v4.IdList.serializeBinaryToWriter
    );
  }
  f = message.getActivityTypeId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional IdList time_row_ids = 1;
 * @return {?proto.wisetime.user.timeline.v4.IdList}
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.prototype.getTimeRowIds = function() {
  return /** @type{?proto.wisetime.user.timeline.v4.IdList} */ (
    jspb.Message.getWrapperField(this, proto.wisetime.user.timeline.v4.IdList, 1));
};


/**
 * @param {?proto.wisetime.user.timeline.v4.IdList|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest} returns this
*/
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.prototype.setTimeRowIds = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest} returns this
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.prototype.clearTimeRowIds = function() {
  return this.setTimeRowIds(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.prototype.hasTimeRowIds = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string activity_type_id = 3;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.prototype.getActivityTypeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest} returns this
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeRequest.prototype.setActivityTypeId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse}
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse;
  return proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse}
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.UnsetActivityTypeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeGroupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    siteId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    timesheetFieldId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    timesheetFieldOptionId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest}
 */
proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest;
  return proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest}
 */
proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeGroupId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimesheetFieldId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimesheetFieldOptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimesheetFieldId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTimesheetFieldOptionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string time_group_id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.prototype.getTimeGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.prototype.setTimeGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string site_id = 4;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string timesheet_field_id = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.prototype.getTimesheetFieldId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.prototype.setTimesheetFieldId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string timesheet_field_option_id = 3;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.prototype.getTimesheetFieldOptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.user.timeline.v4.SelectTimesheetFieldOptionRequest.prototype.setTimesheetFieldOptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeGroupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    siteId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    timesheetFieldId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest}
 */
proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest;
  return proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest}
 */
proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeGroupId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimesheetFieldId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTimesheetFieldId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string time_group_id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.prototype.getTimeGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest} returns this
 */
proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.prototype.setTimeGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string site_id = 3;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest} returns this
 */
proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string timesheet_field_id = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.prototype.getTimesheetFieldId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest} returns this
 */
proto.wisetime.user.timeline.v4.ClearTimesheetFieldRequest.prototype.setTimesheetFieldId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    siteId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    timesheetFieldId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    timesheetFieldOptionId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest}
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest;
  return proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest}
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimeRowIds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimesheetFieldId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimesheetFieldOptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimesheetFieldId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTimesheetFieldOptionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated string time_row_ids = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.prototype.getTimeRowIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.prototype.setTimeRowIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.prototype.addTimeRowIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.prototype.clearTimeRowIdsList = function() {
  return this.setTimeRowIdsList([]);
};


/**
 * optional string site_id = 4;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string timesheet_field_id = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.prototype.getTimesheetFieldId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.prototype.setTimesheetFieldId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string timesheet_field_option_id = 3;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.prototype.getTimesheetFieldOptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionRequest.prototype.setTimesheetFieldOptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowsList: jspb.Message.toObjectList(msg.getTimeRowsList(),
    proto.wisetime.user.timeline.v4.TimeRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse}
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse;
  return proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse}
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.timeline.v4.TimeRow;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.TimeRow.deserializeBinaryFromReader);
      msg.addTimeRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.user.timeline.v4.TimeRow.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TimeRow time_rows = 1;
 * @return {!Array<!proto.wisetime.user.timeline.v4.TimeRow>}
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.prototype.getTimeRowsList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.TimeRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.TimeRow, 1));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.TimeRow>} value
 * @return {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse} returns this
*/
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.prototype.setTimeRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TimeRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.TimeRow}
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.prototype.addTimeRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.user.timeline.v4.TimeRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse} returns this
 */
proto.wisetime.user.timeline.v4.SelectRowTimesheetFieldOptionResponse.prototype.clearTimeRowsList = function() {
  return this.setTimeRowsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    siteId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    timesheetFieldId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest}
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest;
  return proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest}
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimeRowIds(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimesheetFieldId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTimesheetFieldId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated string time_row_ids = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.prototype.getTimeRowIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest} returns this
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.prototype.setTimeRowIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest} returns this
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.prototype.addTimeRowIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest} returns this
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.prototype.clearTimeRowIdsList = function() {
  return this.setTimeRowIdsList([]);
};


/**
 * optional string site_id = 3;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest} returns this
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string timesheet_field_id = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.prototype.getTimesheetFieldId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest} returns this
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldRequest.prototype.setTimesheetFieldId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowsList: jspb.Message.toObjectList(msg.getTimeRowsList(),
    proto.wisetime.user.timeline.v4.TimeRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse}
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse;
  return proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse}
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.timeline.v4.TimeRow;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.TimeRow.deserializeBinaryFromReader);
      msg.addTimeRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.user.timeline.v4.TimeRow.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TimeRow time_rows = 1;
 * @return {!Array<!proto.wisetime.user.timeline.v4.TimeRow>}
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.prototype.getTimeRowsList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.TimeRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.TimeRow, 1));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.TimeRow>} value
 * @return {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse} returns this
*/
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.prototype.setTimeRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TimeRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.TimeRow}
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.prototype.addTimeRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.user.timeline.v4.TimeRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse} returns this
 */
proto.wisetime.user.timeline.v4.ClearRowTimesheetFieldResponse.prototype.clearTimeRowsList = function() {
  return this.setTimeRowsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.TrashTimeRowsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.TrashTimeRowsRequest}
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.TrashTimeRowsRequest;
  return proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.TrashTimeRowsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.TrashTimeRowsRequest}
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimeRowIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.TrashTimeRowsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string time_row_ids = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.prototype.getTimeRowIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.TrashTimeRowsRequest} returns this
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.prototype.setTimeRowIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.TrashTimeRowsRequest} returns this
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.prototype.addTimeRowIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.TrashTimeRowsRequest} returns this
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsRequest.prototype.clearTimeRowIdsList = function() {
  return this.setTimeRowIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.TrashTimeRowsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.TrashTimeRowsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.TrashTimeRowsResponse}
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.TrashTimeRowsResponse;
  return proto.wisetime.user.timeline.v4.TrashTimeRowsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.TrashTimeRowsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.TrashTimeRowsResponse}
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.TrashTimeRowsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.TrashTimeRowsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TrashTimeRowsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest}
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest;
  return proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest}
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimeRowIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string time_row_ids = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.prototype.getTimeRowIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest} returns this
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.prototype.setTimeRowIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest} returns this
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.prototype.addTimeRowIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest} returns this
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsRequest.prototype.clearTimeRowIdsList = function() {
  return this.setTimeRowIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse}
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse;
  return proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse}
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.UnTrashTimeRowsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest}
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest;
  return proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest}
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimeRowIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string time_row_ids = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.prototype.getTimeRowIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest} returns this
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.prototype.setTimeRowIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest} returns this
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.prototype.addTimeRowIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest} returns this
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsRequest.prototype.clearTimeRowIdsList = function() {
  return this.setTimeRowIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse}
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse;
  return proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse}
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ImmediatelyDeleteTimeRowsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.EmptyTrashRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.EmptyTrashRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.EmptyTrashRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.EmptyTrashRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.EmptyTrashRequest}
 */
proto.wisetime.user.timeline.v4.EmptyTrashRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.EmptyTrashRequest;
  return proto.wisetime.user.timeline.v4.EmptyTrashRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.EmptyTrashRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.EmptyTrashRequest}
 */
proto.wisetime.user.timeline.v4.EmptyTrashRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.EmptyTrashRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.EmptyTrashRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.EmptyTrashRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.EmptyTrashRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.EmptyTrashResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.EmptyTrashResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.EmptyTrashResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.EmptyTrashResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    deletedTimeRowsCount: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.EmptyTrashResponse}
 */
proto.wisetime.user.timeline.v4.EmptyTrashResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.EmptyTrashResponse;
  return proto.wisetime.user.timeline.v4.EmptyTrashResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.EmptyTrashResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.EmptyTrashResponse}
 */
proto.wisetime.user.timeline.v4.EmptyTrashResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDeletedTimeRowsCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.EmptyTrashResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.EmptyTrashResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.EmptyTrashResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.EmptyTrashResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeletedTimeRowsCount();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 deleted_time_rows_count = 1;
 * @return {number}
 */
proto.wisetime.user.timeline.v4.EmptyTrashResponse.prototype.getDeletedTimeRowsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.user.timeline.v4.EmptyTrashResponse} returns this
 */
proto.wisetime.user.timeline.v4.EmptyTrashResponse.prototype.setDeletedTimeRowsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.CreateTimeGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    narrativeType: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.CreateTimeGroupRequest}
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.CreateTimeGroupRequest;
  return proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.CreateTimeGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.CreateTimeGroupRequest}
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimeRowIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType} */ (reader.readEnum());
      msg.setNarrativeType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.CreateTimeGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNarrativeType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * repeated string time_row_ids = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.prototype.getTimeRowIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.CreateTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.prototype.setTimeRowIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.CreateTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.prototype.addTimeRowIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.CreateTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.prototype.clearTimeRowIdsList = function() {
  return this.setTimeRowIdsList([]);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.CreateTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.prototype.setName = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.CreateTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.prototype.clearName = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.prototype.hasName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TimeGroup.NarrativeType narrative_type = 4;
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType}
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.prototype.getNarrativeType = function() {
  return /** @type {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType} value
 * @return {!proto.wisetime.user.timeline.v4.CreateTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateTimeGroupRequest.prototype.setNarrativeType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    activityDate: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    narrativeType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    timeZoneOffset: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    narrative: jspb.Message.getFieldWithDefault(msg, 6, ""),
    tagsList: jspb.Message.toObjectList(msg.getTagsList(),
    wisetime_user_type_tag_ref_pb.TagRef.toObject, includeInstance),
    totalDuration: (f = msg.getTotalDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest}
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest;
  return proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest}
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType} */ (reader.readEnum());
      msg.setNarrativeType(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTimeZoneOffset(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNarrative(value);
      break;
    case 7:
      var value = new wisetime_user_type_tag_ref_pb.TagRef;
      reader.readMessage(value,wisetime_user_type_tag_ref_pb.TagRef.deserializeBinaryFromReader);
      msg.addTags(value);
      break;
    case 9:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTotalDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivityDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNarrativeType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTimeZoneOffset();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      wisetime_user_type_tag_ref_pb.TagRef.serializeBinaryToWriter
    );
  }
  f = message.getTotalDuration();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
};


/**
 * optional string activity_date = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.getActivityDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.setActivityDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.setName = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.clearName = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.hasName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TimeGroup.NarrativeType narrative_type = 4;
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType}
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.getNarrativeType = function() {
  return /** @type {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType} value
 * @return {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.setNarrativeType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional double time_zone_offset = 5;
 * @return {number}
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.getTimeZoneOffset = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.setTimeZoneOffset = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string narrative = 6;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.getNarrative = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.setNarrative = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.clearNarrative = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.hasNarrative = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated wisetime.user.type.TagRef tags = 7;
 * @return {!Array<!proto.wisetime.user.type.TagRef>}
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.getTagsList = function() {
  return /** @type{!Array<!proto.wisetime.user.type.TagRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, wisetime_user_type_tag_ref_pb.TagRef, 7));
};


/**
 * @param {!Array<!proto.wisetime.user.type.TagRef>} value
 * @return {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest} returns this
*/
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.setTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.wisetime.user.type.TagRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.type.TagRef}
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.addTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.wisetime.user.type.TagRef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * optional google.protobuf.Duration total_duration = 9;
 * @return {?proto.google.protobuf.Duration}
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.getTotalDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 9));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest} returns this
*/
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.setTotalDuration = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.clearTotalDuration = function() {
  return this.setTotalDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.CreateEmptyTimeGroupRequest.prototype.hasTotalDuration = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.TimeGroup.repeatedFields_ = [6,7,10,17];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.TimeGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.TimeGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TimeGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    narrative: jspb.Message.getFieldWithDefault(msg, 4, ""),
    narrativeType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    timeRowIdsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    tagsList: jspb.Message.toObjectList(msg.getTagsList(),
    wisetime_user_type_tag_ref_pb.TagRef.toObject, includeInstance),
    tagCategoriesList: jspb.Message.toObjectList(msg.getTagCategoriesList(),
    wisetime_user_type_tag_category_ref_pb.TagCategoryRef.toObject, includeInstance),
    selectedTimesheetFieldOptionsList: jspb.Message.toObjectList(msg.getSelectedTimesheetFieldOptionsList(),
    wisetime_user_type_selected_timesheet_field_option_pb.SelectedTimesheetFieldOption.toObject, includeInstance),
    createTime: (f = msg.getCreateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    activityDate: jspb.Message.getFieldWithDefault(msg, 11, ""),
    postStatus: jspb.Message.getFieldWithDefault(msg, 12, 0),
    postedToSiteId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    errorMessage: jspb.Message.getFieldWithDefault(msg, 14, ""),
    totalDuration: (f = msg.getTotalDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    source: jspb.Message.getFieldWithDefault(msg, 16, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup}
 */
proto.wisetime.user.timeline.v4.TimeGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.TimeGroup;
  return proto.wisetime.user.timeline.v4.TimeGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.TimeGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup}
 */
proto.wisetime.user.timeline.v4.TimeGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNarrative(value);
      break;
    case 5:
      var value = /** @type {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType} */ (reader.readEnum());
      msg.setNarrativeType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimeRowIds(value);
      break;
    case 7:
      var value = new wisetime_user_type_tag_ref_pb.TagRef;
      reader.readMessage(value,wisetime_user_type_tag_ref_pb.TagRef.deserializeBinaryFromReader);
      msg.addTags(value);
      break;
    case 10:
      var value = new wisetime_user_type_tag_category_ref_pb.TagCategoryRef;
      reader.readMessage(value,wisetime_user_type_tag_category_ref_pb.TagCategoryRef.deserializeBinaryFromReader);
      msg.addTagCategories(value);
      break;
    case 17:
      var value = new wisetime_user_type_selected_timesheet_field_option_pb.SelectedTimesheetFieldOption;
      reader.readMessage(value,wisetime_user_type_selected_timesheet_field_option_pb.SelectedTimesheetFieldOption.deserializeBinaryFromReader);
      msg.addSelectedTimesheetFieldOptions(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateTime(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityDate(value);
      break;
    case 12:
      var value = /** @type {!proto.wisetime.user.timeline.v4.PostStatus} */ (reader.readEnum());
      msg.setPostStatus(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostedToSiteId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    case 9:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTotalDuration(value);
      break;
    case 16:
      var value = /** @type {!proto.wisetime.user.timeline.v4.TimeGroup.TimeGroupSource} */ (reader.readEnum());
      msg.setSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.TimeGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.TimeGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TimeGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNarrative();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNarrativeType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTimeRowIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      wisetime_user_type_tag_ref_pb.TagRef.serializeBinaryToWriter
    );
  }
  f = message.getTagCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      wisetime_user_type_tag_category_ref_pb.TagCategoryRef.serializeBinaryToWriter
    );
  }
  f = message.getSelectedTimesheetFieldOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      wisetime_user_type_selected_timesheet_field_option_pb.SelectedTimesheetFieldOption.serializeBinaryToWriter
    );
  }
  f = message.getCreateTime();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getActivityDate();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPostStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getPostedToSiteId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTotalDuration();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType = {
  NARRATIVE_TYPE_UNSPECIFIED: 0,
  NARRATIVE_ONLY: 1,
  NARRATIVE_AND_TIME_ROW_DESCRIPTIONS: 2
};

/**
 * @enum {number}
 */
proto.wisetime.user.timeline.v4.TimeGroup.TimeGroupSource = {
  TIME_GROUP_SOURCE_UNDEFINED: 0,
  TIME_GROUP_SOURCE_USER_CREATED: 1,
  TIME_GROUP_SOURCE_BLOCK_POST: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.setName = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.clearName = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.hasName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string narrative = 4;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.getNarrative = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.setNarrative = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional NarrativeType narrative_type = 5;
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.getNarrativeType = function() {
  return /** @type {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.setNarrativeType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * repeated string time_row_ids = 6;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.getTimeRowIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.setTimeRowIdsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.addTimeRowIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.clearTimeRowIdsList = function() {
  return this.setTimeRowIdsList([]);
};


/**
 * repeated wisetime.user.type.TagRef tags = 7;
 * @return {!Array<!proto.wisetime.user.type.TagRef>}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.getTagsList = function() {
  return /** @type{!Array<!proto.wisetime.user.type.TagRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, wisetime_user_type_tag_ref_pb.TagRef, 7));
};


/**
 * @param {!Array<!proto.wisetime.user.type.TagRef>} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
*/
proto.wisetime.user.timeline.v4.TimeGroup.prototype.setTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.wisetime.user.type.TagRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.type.TagRef}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.addTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.wisetime.user.type.TagRef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * repeated wisetime.user.type.TagCategoryRef tag_categories = 10;
 * @return {!Array<!proto.wisetime.user.type.TagCategoryRef>}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.getTagCategoriesList = function() {
  return /** @type{!Array<!proto.wisetime.user.type.TagCategoryRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, wisetime_user_type_tag_category_ref_pb.TagCategoryRef, 10));
};


/**
 * @param {!Array<!proto.wisetime.user.type.TagCategoryRef>} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
*/
proto.wisetime.user.timeline.v4.TimeGroup.prototype.setTagCategoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.wisetime.user.type.TagCategoryRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.type.TagCategoryRef}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.addTagCategories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.wisetime.user.type.TagCategoryRef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.clearTagCategoriesList = function() {
  return this.setTagCategoriesList([]);
};


/**
 * repeated wisetime.user.type.SelectedTimesheetFieldOption selected_timesheet_field_options = 17;
 * @return {!Array<!proto.wisetime.user.type.SelectedTimesheetFieldOption>}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.getSelectedTimesheetFieldOptionsList = function() {
  return /** @type{!Array<!proto.wisetime.user.type.SelectedTimesheetFieldOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, wisetime_user_type_selected_timesheet_field_option_pb.SelectedTimesheetFieldOption, 17));
};


/**
 * @param {!Array<!proto.wisetime.user.type.SelectedTimesheetFieldOption>} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
*/
proto.wisetime.user.timeline.v4.TimeGroup.prototype.setSelectedTimesheetFieldOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.wisetime.user.type.SelectedTimesheetFieldOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.type.SelectedTimesheetFieldOption}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.addSelectedTimesheetFieldOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.wisetime.user.type.SelectedTimesheetFieldOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.clearSelectedTimesheetFieldOptionsList = function() {
  return this.setSelectedTimesheetFieldOptionsList([]);
};


/**
 * optional google.protobuf.Timestamp create_time = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.getCreateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
*/
proto.wisetime.user.timeline.v4.TimeGroup.prototype.setCreateTime = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.clearCreateTime = function() {
  return this.setCreateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.hasCreateTime = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string activity_date = 11;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.getActivityDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.setActivityDate = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional PostStatus post_status = 12;
 * @return {!proto.wisetime.user.timeline.v4.PostStatus}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.getPostStatus = function() {
  return /** @type {!proto.wisetime.user.timeline.v4.PostStatus} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.wisetime.user.timeline.v4.PostStatus} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.setPostStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional string posted_to_site_id = 13;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.getPostedToSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.setPostedToSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string error_message = 14;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional google.protobuf.Duration total_duration = 9;
 * @return {?proto.google.protobuf.Duration}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.getTotalDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 9));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
*/
proto.wisetime.user.timeline.v4.TimeGroup.prototype.setTotalDuration = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.clearTotalDuration = function() {
  return this.setTotalDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.hasTotalDuration = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional TimeGroupSource source = 16;
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup.TimeGroupSource}
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.getSource = function() {
  return /** @type {!proto.wisetime.user.timeline.v4.TimeGroup.TimeGroupSource} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TimeGroup.TimeGroupSource} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroup.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.AddToTimeGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    timeGroupId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.AddToTimeGroupRequest}
 */
proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.AddToTimeGroupRequest;
  return proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.AddToTimeGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.AddToTimeGroupRequest}
 */
proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimeRowIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.AddToTimeGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getTimeGroupId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated string time_row_ids = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.prototype.getTimeRowIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.AddToTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.prototype.setTimeRowIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.AddToTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.prototype.addTimeRowIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.AddToTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.prototype.clearTimeRowIdsList = function() {
  return this.setTimeRowIdsList([]);
};


/**
 * optional string time_group_id = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.prototype.getTimeGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.AddToTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.AddToTimeGroupRequest.prototype.setTimeGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeRowIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    timeGroupId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest}
 */
proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest;
  return proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest}
 */
proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimeRowIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRowIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getTimeGroupId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated string time_row_ids = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.prototype.getTimeRowIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.prototype.setTimeRowIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.prototype.addTimeRowIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.prototype.clearTimeRowIdsList = function() {
  return this.setTimeRowIdsList([]);
};


/**
 * optional string time_group_id = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.prototype.getTimeGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.RemoveFromTimeGroupRequest.prototype.setTimeGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeGroupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    totalDuration: (f = msg.getTotalDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest;
  return proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeGroupId(value);
      break;
    case 6:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTotalDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalDuration();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
};


/**
 * optional string time_group_id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.prototype.getTimeGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest} returns this
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.prototype.setTimeGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Duration total_duration = 6;
 * @return {?proto.google.protobuf.Duration}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.prototype.getTotalDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 6));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest} returns this
*/
proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.prototype.setTotalDuration = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest} returns this
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.prototype.clearTotalDuration = function() {
  return this.setTotalDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupDurationRequest.prototype.hasTotalDuration = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    timeGroup: (f = msg.getTimeGroup()) && proto.wisetime.user.timeline.v4.TimeGroupUpdate.toObject(includeInstance, f),
    updateMask: (f = msg.getUpdateMask()) && google_protobuf_field_mask_pb.FieldMask.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest;
  return proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.wisetime.user.timeline.v4.TimeGroupUpdate;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.TimeGroupUpdate.deserializeBinaryFromReader);
      msg.setTimeGroup(value);
      break;
    case 3:
      var value = new google_protobuf_field_mask_pb.FieldMask;
      reader.readMessage(value,google_protobuf_field_mask_pb.FieldMask.deserializeBinaryFromReader);
      msg.setUpdateMask(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTimeGroup();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.wisetime.user.timeline.v4.TimeGroupUpdate.serializeBinaryToWriter
    );
  }
  f = message.getUpdateMask();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_field_mask_pb.FieldMask.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional TimeGroupUpdate time_group = 2;
 * @return {?proto.wisetime.user.timeline.v4.TimeGroupUpdate}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.prototype.getTimeGroup = function() {
  return /** @type{?proto.wisetime.user.timeline.v4.TimeGroupUpdate} */ (
    jspb.Message.getWrapperField(this, proto.wisetime.user.timeline.v4.TimeGroupUpdate, 2));
};


/**
 * @param {?proto.wisetime.user.timeline.v4.TimeGroupUpdate|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest} returns this
*/
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.prototype.setTimeGroup = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.prototype.clearTimeGroup = function() {
  return this.setTimeGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.prototype.hasTimeGroup = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.FieldMask update_mask = 3;
 * @return {?proto.google.protobuf.FieldMask}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.prototype.getUpdateMask = function() {
  return /** @type{?proto.google.protobuf.FieldMask} */ (
    jspb.Message.getWrapperField(this, google_protobuf_field_mask_pb.FieldMask, 3));
};


/**
 * @param {?proto.google.protobuf.FieldMask|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest} returns this
*/
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.prototype.setUpdateMask = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.prototype.clearUpdateMask = function() {
  return this.setUpdateMask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.UpdateTimeGroupRequest.prototype.hasUpdateMask = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.TimeGroupUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.TimeGroupUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    narrative: jspb.Message.getFieldWithDefault(msg, 2, ""),
    narrativeType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    narrativeSource: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.TimeGroupUpdate}
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.TimeGroupUpdate;
  return proto.wisetime.user.timeline.v4.TimeGroupUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.TimeGroupUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.TimeGroupUpdate}
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNarrative(value);
      break;
    case 3:
      var value = /** @type {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType} */ (reader.readEnum());
      msg.setNarrativeType(value);
      break;
    case 4:
      var value = /** @type {!proto.wisetime.user.timeline.v4.NarrativeSource} */ (reader.readEnum());
      msg.setNarrativeSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.TimeGroupUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.TimeGroupUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNarrative();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNarrativeType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getNarrativeSource();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroupUpdate} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.prototype.setName = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.TimeGroupUpdate} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.prototype.clearName = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.prototype.hasName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string narrative = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.prototype.getNarrative = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroupUpdate} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.prototype.setNarrative = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional TimeGroup.NarrativeType narrative_type = 3;
 * @return {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType}
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.prototype.getNarrativeType = function() {
  return /** @type {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TimeGroup.NarrativeType} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroupUpdate} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.prototype.setNarrativeType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional NarrativeSource narrative_source = 4;
 * @return {!proto.wisetime.user.timeline.v4.NarrativeSource}
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.prototype.getNarrativeSource = function() {
  return /** @type {!proto.wisetime.user.timeline.v4.NarrativeSource} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.wisetime.user.timeline.v4.NarrativeSource} value
 * @return {!proto.wisetime.user.timeline.v4.TimeGroupUpdate} returns this
 */
proto.wisetime.user.timeline.v4.TimeGroupUpdate.prototype.setNarrativeSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeGroupId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest}
 */
proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest;
  return proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest}
 */
proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string time_group_id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest.prototype.getTimeGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest} returns this
 */
proto.wisetime.user.timeline.v4.DeleteTimeGroupRequest.prototype.setTimeGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.AffectedRowsResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.AffectedRowsResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    segmentHoursList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    timeRowIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.AffectedRowsResult}
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.AffectedRowsResult;
  return proto.wisetime.user.timeline.v4.AffectedRowsResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.AffectedRowsResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.AffectedRowsResult}
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addSegmentHours(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimeRowIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.AffectedRowsResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.AffectedRowsResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSegmentHoursList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getTimeRowIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string segment_hours = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult.prototype.getSegmentHoursList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.AffectedRowsResult} returns this
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult.prototype.setSegmentHoursList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.AffectedRowsResult} returns this
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult.prototype.addSegmentHours = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.AffectedRowsResult} returns this
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult.prototype.clearSegmentHoursList = function() {
  return this.setSegmentHoursList([]);
};


/**
 * repeated string time_row_ids = 2;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult.prototype.getTimeRowIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.AffectedRowsResult} returns this
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult.prototype.setTimeRowIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.AffectedRowsResult} returns this
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult.prototype.addTimeRowIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.AffectedRowsResult} returns this
 */
proto.wisetime.user.timeline.v4.AffectedRowsResult.prototype.clearTimeRowIdsList = function() {
  return this.setTimeRowIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    description: jspb.Message.getFieldWithDefault(msg, 1, ""),
    date: jspb.Message.getFieldWithDefault(msg, 2, ""),
    startTime: (f = msg.getStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    timeZoneOffset: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest}
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest;
  return proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest}
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartTime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTimeZoneOffset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStartTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTimeZoneOffset();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional string description = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string date = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp start_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.prototype.getStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest} returns this
*/
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.prototype.setStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.prototype.clearStartTime = function() {
  return this.setStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.prototype.hasStartTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional double time_zone_offset = 4;
 * @return {number}
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.prototype.getTimeZoneOffset = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest} returns this
 */
proto.wisetime.user.timeline.v4.CreateTimelineMarkerRequest.prototype.setTimeZoneOffset = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest}
 */
proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest;
  return proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest}
 */
proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest} returns this
 */
proto.wisetime.user.timeline.v4.DeleteTimelineMarkerRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.AddManualTimeRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.AddManualTimeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.AddManualTimeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.AddManualTimeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AddManualTimeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    manualTimeRowsList: jspb.Message.toObjectList(msg.getManualTimeRowsList(),
    proto.wisetime.user.timeline.v4.ManualTimeRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.AddManualTimeRequest}
 */
proto.wisetime.user.timeline.v4.AddManualTimeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.AddManualTimeRequest;
  return proto.wisetime.user.timeline.v4.AddManualTimeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.AddManualTimeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.AddManualTimeRequest}
 */
proto.wisetime.user.timeline.v4.AddManualTimeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.wisetime.user.timeline.v4.ManualTimeRow;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.ManualTimeRow.deserializeBinaryFromReader);
      msg.addManualTimeRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.AddManualTimeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.AddManualTimeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.AddManualTimeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AddManualTimeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManualTimeRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.wisetime.user.timeline.v4.ManualTimeRow.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ManualTimeRow manual_time_rows = 2;
 * @return {!Array<!proto.wisetime.user.timeline.v4.ManualTimeRow>}
 */
proto.wisetime.user.timeline.v4.AddManualTimeRequest.prototype.getManualTimeRowsList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.ManualTimeRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.ManualTimeRow, 2));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.ManualTimeRow>} value
 * @return {!proto.wisetime.user.timeline.v4.AddManualTimeRequest} returns this
*/
proto.wisetime.user.timeline.v4.AddManualTimeRequest.prototype.setManualTimeRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.ManualTimeRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.ManualTimeRow}
 */
proto.wisetime.user.timeline.v4.AddManualTimeRequest.prototype.addManualTimeRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.wisetime.user.timeline.v4.ManualTimeRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.AddManualTimeRequest} returns this
 */
proto.wisetime.user.timeline.v4.AddManualTimeRequest.prototype.clearManualTimeRowsList = function() {
  return this.setManualTimeRowsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.ManualTimeRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.ManualTimeRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    activityHour: jspb.Message.getFieldWithDefault(msg, 1, 0),
    minutes: jspb.Message.getFieldWithDefault(msg, 2, 0),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    timeZone: jspb.Message.getFieldWithDefault(msg, 5, ""),
    timeZoneOffset: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    category: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.ManualTimeRow}
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.ManualTimeRow;
  return proto.wisetime.user.timeline.v4.ManualTimeRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.ManualTimeRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.ManualTimeRow}
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setActivityHour(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMinutes(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeZone(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTimeZoneOffset(value);
      break;
    case 7:
      var value = /** @type {!proto.wisetime.user.timeline.v4.ManualTimeRow.ManualTimeCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.ManualTimeRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.ManualTimeRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivityHour();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getMinutes();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTimeZone();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTimeZoneOffset();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.ManualTimeCategory = {
  MANUAL_TIME_CATEGORY_UNSPECIFIED: 0,
  OTHER: 1,
  READING: 2,
  TRAVEL: 3,
  VIDEO_CALL: 4,
  PHONE_CALL: 5,
  MEETING: 6,
  THINKING: 7,
  PAPER_WORK: 8,
  ON_LEAVE: 9,
  RESEARCHING: 10,
  DRAFTING: 11,
  CORRESPONDING: 12
};

/**
 * optional uint32 activity_hour = 1;
 * @return {number}
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.prototype.getActivityHour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.user.timeline.v4.ManualTimeRow} returns this
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.prototype.setActivityHour = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 minutes = 2;
 * @return {number}
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.prototype.getMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.user.timeline.v4.ManualTimeRow} returns this
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.prototype.setMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.ManualTimeRow} returns this
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string time_zone = 5;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.prototype.getTimeZone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.ManualTimeRow} returns this
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.prototype.setTimeZone = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional double time_zone_offset = 6;
 * @return {number}
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.prototype.getTimeZoneOffset = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.user.timeline.v4.ManualTimeRow} returns this
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.prototype.setTimeZoneOffset = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional ManualTimeCategory category = 7;
 * @return {!proto.wisetime.user.timeline.v4.ManualTimeRow.ManualTimeCategory}
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.prototype.getCategory = function() {
  return /** @type {!proto.wisetime.user.timeline.v4.ManualTimeRow.ManualTimeCategory} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.wisetime.user.timeline.v4.ManualTimeRow.ManualTimeCategory} value
 * @return {!proto.wisetime.user.timeline.v4.ManualTimeRow} returns this
 */
proto.wisetime.user.timeline.v4.ManualTimeRow.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.AddManualTimeResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.AddManualTimeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.AddManualTimeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.AddManualTimeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AddManualTimeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    newTimeRowIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.AddManualTimeResponse}
 */
proto.wisetime.user.timeline.v4.AddManualTimeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.AddManualTimeResponse;
  return proto.wisetime.user.timeline.v4.AddManualTimeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.AddManualTimeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.AddManualTimeResponse}
 */
proto.wisetime.user.timeline.v4.AddManualTimeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addNewTimeRowIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.AddManualTimeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.AddManualTimeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.AddManualTimeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.AddManualTimeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewTimeRowIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string new_time_row_ids = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.AddManualTimeResponse.prototype.getNewTimeRowIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.AddManualTimeResponse} returns this
 */
proto.wisetime.user.timeline.v4.AddManualTimeResponse.prototype.setNewTimeRowIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.AddManualTimeResponse} returns this
 */
proto.wisetime.user.timeline.v4.AddManualTimeResponse.prototype.addNewTimeRowIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.AddManualTimeResponse} returns this
 */
proto.wisetime.user.timeline.v4.AddManualTimeResponse.prototype.clearNewTimeRowIdsList = function() {
  return this.setNewTimeRowIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeGroupIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest}
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest;
  return proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest}
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimeGroupIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeGroupIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string time_group_ids = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.prototype.getTimeGroupIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest} returns this
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.prototype.setTimeGroupIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest} returns this
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.prototype.addTimeGroupIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest} returns this
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsRequest.prototype.clearTimeGroupIdsList = function() {
  return this.setTimeGroupIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    affectedTimeGroupIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    affectedTimeRowIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse}
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse;
  return proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse}
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAffectedTimeGroupIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAffectedTimeRowIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAffectedTimeGroupIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getAffectedTimeRowIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string affected_time_group_ids = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.prototype.getAffectedTimeGroupIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse} returns this
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.prototype.setAffectedTimeGroupIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse} returns this
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.prototype.addAffectedTimeGroupIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse} returns this
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.prototype.clearAffectedTimeGroupIdsList = function() {
  return this.setAffectedTimeGroupIdsList([]);
};


/**
 * repeated string affected_time_row_ids = 2;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.prototype.getAffectedTimeRowIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse} returns this
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.prototype.setAffectedTimeRowIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse} returns this
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.prototype.addAffectedTimeRowIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse} returns this
 */
proto.wisetime.user.timeline.v4.ClearTimeGroupErrorsResponse.prototype.clearAffectedTimeRowIdsList = function() {
  return this.setAffectedTimeRowIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.TimeRow.repeatedFields_ = [12,21,13,23];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.TimeRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.TimeRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TimeRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    timeGroupId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    activity: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    iconUrl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    duration: (f = msg.getDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    activityDate: jspb.Message.getFieldWithDefault(msg, 22, ""),
    activityHour: jspb.Message.getFieldWithDefault(msg, 8, 0),
    firstObservedInHour: jspb.Message.getFieldWithDefault(msg, 9, 0),
    timeZone: jspb.Message.getFieldWithDefault(msg, 10, ""),
    timeZoneOffset: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    tagsList: jspb.Message.toObjectList(msg.getTagsList(),
    wisetime_user_type_tag_ref_pb.TagRef.toObject, includeInstance),
    tagCategoriesList: jspb.Message.toObjectList(msg.getTagCategoriesList(),
    wisetime_user_type_tag_category_ref_pb.TagCategoryRef.toObject, includeInstance),
    tagSuggestionsList: jspb.Message.toObjectList(msg.getTagSuggestionsList(),
    proto.wisetime.user.timeline.v4.TagSuggestion.toObject, includeInstance),
    selectedTimesheetFieldOptionsList: jspb.Message.toObjectList(msg.getSelectedTimesheetFieldOptionsList(),
    wisetime_user_type_selected_timesheet_field_option_pb.SelectedTimesheetFieldOption.toObject, includeInstance),
    trashStatus: jspb.Message.getFieldWithDefault(msg, 18, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.TimeRow}
 */
proto.wisetime.user.timeline.v4.TimeRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.TimeRow;
  return proto.wisetime.user.timeline.v4.TimeRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.TimeRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.TimeRow}
 */
proto.wisetime.user.timeline.v4.TimeRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeGroupId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivity(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setIconUrl(value);
      break;
    case 7:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityDate(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setActivityHour(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFirstObservedInHour(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeZone(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTimeZoneOffset(value);
      break;
    case 12:
      var value = new wisetime_user_type_tag_ref_pb.TagRef;
      reader.readMessage(value,wisetime_user_type_tag_ref_pb.TagRef.deserializeBinaryFromReader);
      msg.addTags(value);
      break;
    case 21:
      var value = new wisetime_user_type_tag_category_ref_pb.TagCategoryRef;
      reader.readMessage(value,wisetime_user_type_tag_category_ref_pb.TagCategoryRef.deserializeBinaryFromReader);
      msg.addTagCategories(value);
      break;
    case 13:
      var value = new proto.wisetime.user.timeline.v4.TagSuggestion;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.TagSuggestion.deserializeBinaryFromReader);
      msg.addTagSuggestions(value);
      break;
    case 23:
      var value = new wisetime_user_type_selected_timesheet_field_option_pb.SelectedTimesheetFieldOption;
      reader.readMessage(value,wisetime_user_type_selected_timesheet_field_option_pb.SelectedTimesheetFieldOption.deserializeBinaryFromReader);
      msg.addSelectedTimesheetFieldOptions(value);
      break;
    case 18:
      var value = /** @type {!proto.wisetime.user.timeline.v4.TrashStatus} */ (reader.readEnum());
      msg.setTrashStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.TimeRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.TimeRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TimeRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTimeGroupId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActivity();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIconUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getActivityDate();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getActivityHour();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getFirstObservedInHour();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getTimeZone();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTimeZoneOffset();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      wisetime_user_type_tag_ref_pb.TagRef.serializeBinaryToWriter
    );
  }
  f = message.getTagCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      21,
      f,
      wisetime_user_type_tag_category_ref_pb.TagCategoryRef.serializeBinaryToWriter
    );
  }
  f = message.getTagSuggestionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.wisetime.user.timeline.v4.TagSuggestion.serializeBinaryToWriter
    );
  }
  f = message.getSelectedTimesheetFieldOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      23,
      f,
      wisetime_user_type_selected_timesheet_field_option_pb.SelectedTimesheetFieldOption.serializeBinaryToWriter
    );
  }
  f = message.getTrashStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string time_group_id = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getTimeGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.setTimeGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string activity = 3;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getActivity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.setActivity = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string icon_url = 5;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getIconUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.setIconUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Duration duration = 7;
 * @return {?proto.google.protobuf.Duration}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 7));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
*/
proto.wisetime.user.timeline.v4.TimeRow.prototype.setDuration = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.clearDuration = function() {
  return this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string activity_date = 22;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getActivityDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.setActivityDate = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional uint32 activity_hour = 8;
 * @return {number}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getActivityHour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.setActivityHour = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 first_observed_in_hour = 9;
 * @return {number}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getFirstObservedInHour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.setFirstObservedInHour = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string time_zone = 10;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getTimeZone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.setTimeZone = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional double time_zone_offset = 11;
 * @return {number}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getTimeZoneOffset = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.setTimeZoneOffset = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * repeated wisetime.user.type.TagRef tags = 12;
 * @return {!Array<!proto.wisetime.user.type.TagRef>}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getTagsList = function() {
  return /** @type{!Array<!proto.wisetime.user.type.TagRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, wisetime_user_type_tag_ref_pb.TagRef, 12));
};


/**
 * @param {!Array<!proto.wisetime.user.type.TagRef>} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
*/
proto.wisetime.user.timeline.v4.TimeRow.prototype.setTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.wisetime.user.type.TagRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.type.TagRef}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.addTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.wisetime.user.type.TagRef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * repeated wisetime.user.type.TagCategoryRef tag_categories = 21;
 * @return {!Array<!proto.wisetime.user.type.TagCategoryRef>}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getTagCategoriesList = function() {
  return /** @type{!Array<!proto.wisetime.user.type.TagCategoryRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, wisetime_user_type_tag_category_ref_pb.TagCategoryRef, 21));
};


/**
 * @param {!Array<!proto.wisetime.user.type.TagCategoryRef>} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
*/
proto.wisetime.user.timeline.v4.TimeRow.prototype.setTagCategoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 21, value);
};


/**
 * @param {!proto.wisetime.user.type.TagCategoryRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.type.TagCategoryRef}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.addTagCategories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.wisetime.user.type.TagCategoryRef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.clearTagCategoriesList = function() {
  return this.setTagCategoriesList([]);
};


/**
 * repeated TagSuggestion tag_suggestions = 13;
 * @return {!Array<!proto.wisetime.user.timeline.v4.TagSuggestion>}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getTagSuggestionsList = function() {
  return /** @type{!Array<!proto.wisetime.user.timeline.v4.TagSuggestion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timeline.v4.TagSuggestion, 13));
};


/**
 * @param {!Array<!proto.wisetime.user.timeline.v4.TagSuggestion>} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
*/
proto.wisetime.user.timeline.v4.TimeRow.prototype.setTagSuggestionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TagSuggestion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.TagSuggestion}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.addTagSuggestions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.wisetime.user.timeline.v4.TagSuggestion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.clearTagSuggestionsList = function() {
  return this.setTagSuggestionsList([]);
};


/**
 * repeated wisetime.user.type.SelectedTimesheetFieldOption selected_timesheet_field_options = 23;
 * @return {!Array<!proto.wisetime.user.type.SelectedTimesheetFieldOption>}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getSelectedTimesheetFieldOptionsList = function() {
  return /** @type{!Array<!proto.wisetime.user.type.SelectedTimesheetFieldOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, wisetime_user_type_selected_timesheet_field_option_pb.SelectedTimesheetFieldOption, 23));
};


/**
 * @param {!Array<!proto.wisetime.user.type.SelectedTimesheetFieldOption>} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
*/
proto.wisetime.user.timeline.v4.TimeRow.prototype.setSelectedTimesheetFieldOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 23, value);
};


/**
 * @param {!proto.wisetime.user.type.SelectedTimesheetFieldOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.type.SelectedTimesheetFieldOption}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.addSelectedTimesheetFieldOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 23, opt_value, proto.wisetime.user.type.SelectedTimesheetFieldOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.clearSelectedTimesheetFieldOptionsList = function() {
  return this.setSelectedTimesheetFieldOptionsList([]);
};


/**
 * optional TrashStatus trash_status = 18;
 * @return {!proto.wisetime.user.timeline.v4.TrashStatus}
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.getTrashStatus = function() {
  return /** @type {!proto.wisetime.user.timeline.v4.TrashStatus} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {!proto.wisetime.user.timeline.v4.TrashStatus} value
 * @return {!proto.wisetime.user.timeline.v4.TimeRow} returns this
 */
proto.wisetime.user.timeline.v4.TimeRow.prototype.setTrashStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.TagSuggestion.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.TagSuggestion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.TagSuggestion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TagSuggestion.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tag: (f = msg.getTag()) && wisetime_user_type_tag_ref_pb.TagRef.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.TagSuggestion}
 */
proto.wisetime.user.timeline.v4.TagSuggestion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.TagSuggestion;
  return proto.wisetime.user.timeline.v4.TagSuggestion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.TagSuggestion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.TagSuggestion}
 */
proto.wisetime.user.timeline.v4.TagSuggestion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new wisetime_user_type_tag_ref_pb.TagRef;
      reader.readMessage(value,wisetime_user_type_tag_ref_pb.TagRef.deserializeBinaryFromReader);
      msg.setTag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.TagSuggestion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.TagSuggestion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.TagSuggestion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TagSuggestion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTag();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      wisetime_user_type_tag_ref_pb.TagRef.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TagSuggestion.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TagSuggestion} returns this
 */
proto.wisetime.user.timeline.v4.TagSuggestion.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional wisetime.user.type.TagRef tag = 2;
 * @return {?proto.wisetime.user.type.TagRef}
 */
proto.wisetime.user.timeline.v4.TagSuggestion.prototype.getTag = function() {
  return /** @type{?proto.wisetime.user.type.TagRef} */ (
    jspb.Message.getWrapperField(this, wisetime_user_type_tag_ref_pb.TagRef, 2));
};


/**
 * @param {?proto.wisetime.user.type.TagRef|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.TagSuggestion} returns this
*/
proto.wisetime.user.timeline.v4.TagSuggestion.prototype.setTag = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.TagSuggestion} returns this
 */
proto.wisetime.user.timeline.v4.TagSuggestion.prototype.clearTag = function() {
  return this.setTag(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.TagSuggestion.prototype.hasTag = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.TimelineMarker.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.TimelineMarker.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.TimelineMarker} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TimelineMarker.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    date: jspb.Message.getFieldWithDefault(msg, 3, ""),
    startTime: (f = msg.getStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endTime: (f = msg.getEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    timeZoneOffset: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    tagsList: jspb.Message.toObjectList(msg.getTagsList(),
    wisetime_user_type_tag_ref_pb.TagRef.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.TimelineMarker}
 */
proto.wisetime.user.timeline.v4.TimelineMarker.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.TimelineMarker;
  return proto.wisetime.user.timeline.v4.TimelineMarker.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.TimelineMarker} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.TimelineMarker}
 */
proto.wisetime.user.timeline.v4.TimelineMarker.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartTime(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndTime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTimeZoneOffset(value);
      break;
    case 7:
      var value = new wisetime_user_type_tag_ref_pb.TagRef;
      reader.readMessage(value,wisetime_user_type_tag_ref_pb.TagRef.deserializeBinaryFromReader);
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.TimelineMarker.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.TimelineMarker} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.TimelineMarker.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStartTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTimeZoneOffset();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      wisetime_user_type_tag_ref_pb.TagRef.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimelineMarker} returns this
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimelineMarker} returns this
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string date = 3;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.TimelineMarker} returns this
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp start_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.getStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.TimelineMarker} returns this
*/
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.setStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.TimelineMarker} returns this
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.clearStartTime = function() {
  return this.setStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.hasStartTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp end_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.getEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.TimelineMarker} returns this
*/
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.setEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.TimelineMarker} returns this
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.clearEndTime = function() {
  return this.setEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.hasEndTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional double time_zone_offset = 6;
 * @return {number}
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.getTimeZoneOffset = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.user.timeline.v4.TimelineMarker} returns this
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.setTimeZoneOffset = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * repeated wisetime.user.type.TagRef tags = 7;
 * @return {!Array<!proto.wisetime.user.type.TagRef>}
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.getTagsList = function() {
  return /** @type{!Array<!proto.wisetime.user.type.TagRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, wisetime_user_type_tag_ref_pb.TagRef, 7));
};


/**
 * @param {!Array<!proto.wisetime.user.type.TagRef>} value
 * @return {!proto.wisetime.user.timeline.v4.TimelineMarker} returns this
*/
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.setTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.wisetime.user.type.TagRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.type.TagRef}
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.addTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.wisetime.user.type.TagRef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.TimelineMarker} returns this
 */
proto.wisetime.user.timeline.v4.TimelineMarker.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: jspb.Message.getFieldWithDefault(msg, 1, ""),
    endDate: jspb.Message.getFieldWithDefault(msg, 2, ""),
    filter: (f = msg.getFilter()) && proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest;
  return proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndDate(value);
      break;
    case 4:
      var value = new proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter;
      reader.readMessage(value,proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEndDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.toObject = function(includeInstance, msg) {
  var f, obj = {
    activitiesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    descriptionsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    tagIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter;
  return proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addActivities(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addDescriptions(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addTagIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivitiesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getDescriptionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getTagIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * repeated string activities = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.prototype.getActivitiesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter} returns this
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.prototype.setActivitiesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter} returns this
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.prototype.addActivities = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter} returns this
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.prototype.clearActivitiesList = function() {
  return this.setActivitiesList([]);
};


/**
 * repeated string descriptions = 2;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.prototype.getDescriptionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter} returns this
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.prototype.setDescriptionsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter} returns this
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.prototype.addDescriptions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter} returns this
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.prototype.clearDescriptionsList = function() {
  return this.setDescriptionsList([]);
};


/**
 * repeated string tag_ids = 3;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.prototype.getTagIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter} returns this
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.prototype.setTagIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter} returns this
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.prototype.addTagIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter} returns this
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter.prototype.clearTagIdsList = function() {
  return this.setTagIdsList([]);
};


/**
 * optional string start_date = 1;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest} returns this
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string end_date = 2;
 * @return {string}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.prototype.getEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest} returns this
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Filter filter = 4;
 * @return {?proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.prototype.getFilter = function() {
  return /** @type{?proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter} */ (
    jspb.Message.getWrapperField(this, proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter, 4));
};


/**
 * @param {?proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.Filter|undefined} value
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest} returns this
*/
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.prototype.setFilter = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest} returns this
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsRequest.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    dayCountsMap: (f = msg.getDayCountsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse;
  return proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getDayCountsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readUint32, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDayCountsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeUint32);
  }
};


/**
 * map<string, uint32> day_counts = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse.prototype.getDayCountsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse} returns this
 */
proto.wisetime.user.timeline.v4.CountFilteredTimeRowsResponse.prototype.clearDayCountsMap = function() {
  this.getDayCountsMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeGroupIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest}
 */
proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest;
  return proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest}
 */
proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTimeGroupIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeGroupIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string time_group_ids = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.prototype.getTimeGroupIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest} returns this
 */
proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.prototype.setTimeGroupIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest} returns this
 */
proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.prototype.addTimeGroupIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest} returns this
 */
proto.wisetime.user.timeline.v4.MergeTimeGroupsRequest.prototype.clearTimeGroupIdsList = function() {
  return this.setTimeGroupIdsList([]);
};


/**
 * @enum {number}
 */
proto.wisetime.user.timeline.v4.NarrativeSource = {
  NARRATIVE_SOURCE_UNSPECIFIED: 0,
  USER: 1,
  AI_GENERATED: 2
};

/**
 * @enum {number}
 */
proto.wisetime.user.timeline.v4.PostStatus = {
  NOT_POSTED: 0,
  PENDING: 1,
  TRANSIENT_FAILURE: 2,
  FAILED: 3,
  SUCCESS: 5
};

/**
 * @enum {number}
 */
proto.wisetime.user.timeline.v4.TrashStatus = {
  NOT_TRASHED: 0,
  TRASHED: 1
};

goog.object.extend(exports, proto.wisetime.user.timeline.v4);
